/* Guided Storybooks: presentation and in-memory child roster. The host keeps
   ownership of preview rendering, validation and the existing cart contract. */
(function () {
  'use strict';
  var PRIMARY = 'primary';
  var colouringManifests = {};
  var readerScript = typeof document !== 'undefined' && document.currentScript;
  var colouringPagesUrl = readerScript && readerScript.src ? new URL('ll-colouring-pages-v4.json', readerScript.src).href : '';
  function colouringPages(url, storyId) {
    if (!url) return Promise.reject(new Error('Colouring pages unavailable'));
    if (!colouringManifests[url]) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 12000);
      colouringManifests[url] = fetch(url, { signal: controller.signal }).then(function (response) {
        if (!response.ok) throw new Error('Colouring pages unavailable');
        return response.json();
      }).catch(function (error) { delete colouringManifests[url]; throw error; }).finally(function () { clearTimeout(timer); });
    }
    return colouringManifests[url].then(function (manifest) {
      var prefix = { luna_the_shy_dragon: 'dragon', rainbow_kingdom: 'rainbow', dino_herd: 'dino' }[storyId];
      var pages = manifest.version === 1 && manifest.books && manifest.books[storyId];
      if (!Array.isArray(pages) || pages.length !== 24 || pages.some(function (page) {
        return !prefix || !new RegExp('^ll-colouring-' + prefix + '-(0[1-9]|1[0-2])-v4\\.webp$').test(page.asset) || [0, 1].indexOf(page.side) === -1
          || (page.zone && ['x', 'y', 'w', 'h'].some(function (key) { return !Number.isFinite(page.zone[key]) || page.zone[key] < 0 || page.zone[key] > 100; }));
      })) throw new Error('Colouring pages incomplete');
      return pages;
    });
  }
  function singleChild(offer) { return window.LLBooksOffers.requiresSingleChild(offer); }
  /* A bundle with nothing to choose (Their Complete Collection: six fixed
     books) has no books step; its review still shows every book. */
  function choosesBooks(offer) {
    var offers = window.LLBooksOffers;
    return offer !== 'single' && !(offers && offers.fixedSlots && offers.fixedSlots(offer));
  }
  /* The free printable on the review is advertised on the pair only. An
     older ll-books-offers.js (a partial theme deploy) has no
     hasPrintableBonus: the same rule applies then. */
  function showsPrintableBonus(offers, offer, bundle) {
    if (offers && typeof offers.hasPrintableBonus === 'function') return offers.hasPrintableBonus(bundle);
    return offer === 'two-stories' && Boolean(bundle && bundle.bonusText);
  }
  /* The arrival window in working days: the page's own window for a country
     that has one (data-arrival-min/max), otherwise the 8th to 10th. */
  function arrivalRange(today, minDays, maxDays) {
    var custom = minDays > 0 && maxDays >= minDays && Math.floor(minDays) === minDays && Math.floor(maxDays) === maxDays;
    var min = custom ? minDays : 8, max = custom ? maxDays : 10;
    var date = new Date(today.getTime()), first;
    date.setHours(12, 0, 0, 0);
    for (var days = 0; days < max;) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) days++;
      if (days === min && !first) first = new Date(date.getTime());
    }
    var sameYear = first.getFullYear() === date.getFullYear();
    var format = new Intl.DateTimeFormat('en-US', sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' });
    var last = sameYear && first.getMonth() === date.getMonth() ? String(date.getDate()) : format.format(date);
    return format.format(first) + '–' + last;
  }
  /* A conservative US book estimate: ten full business days after the
     shopper's local order date, excluding observed national holidays.
     Calendar rules: https://www.opm.gov/policy-data-oversight/pay-leave/federal-holidays/ */
  function usBusinessDay(date) {
    var weekday = date.getDay(), month = date.getMonth(), day = date.getDate(), year = date.getFullYear();
    if (weekday === 0 || weekday === 6) return false;
    var week = Math.ceil(day / 7);
    if (weekday === 1 && ((month === 0 && week === 3) || (month === 1 && week === 3)
      || (month === 4 && day >= 25) || (month === 8 && week === 1) || (month === 9 && week === 2))) return false;
    if (month === 10 && weekday === 4 && week === 4) return false;
    // Include next January: its Saturday holiday can be observed on Dec 31.
    return ![year, year + 1].some(function (holidayYear) {
      return [[0, 1], [5, 19], [6, 4], [10, 11], [11, 25]].some(function (holiday) {
        var observed = new Date(holidayYear, holiday[0], holiday[1], 12);
        if (observed.getDay() === 6) observed.setDate(observed.getDate() - 1);
        else if (observed.getDay() === 0) observed.setDate(observed.getDate() + 1);
        return observed.getFullYear() === year && observed.getMonth() === month && observed.getDate() === day;
      });
    });
  }
  function usBookArrivalDate(today) {
    if (!Number.isFinite(today.getTime())) throw new Error('Invalid order date');
    var date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12);
    for (var days = 0; days < 10;) {
      date.setDate(date.getDate() + 1);
      if (usBusinessDay(date)) days++;
    }
    return date;
  }
  function renderUsBookArrivals() {
    try {
      var today = new Date(), date = usBookArrivalDate(today);
      var options = { weekday: 'short', month: 'short', day: 'numeric' };
      if (date.getFullYear() !== today.getFullYear()) options.year = 'numeric';
      var formatted = new Intl.DateTimeFormat('en-US', options).format(date);
      document.querySelectorAll('[data-us-book-arrival]').forEach(function (element) {
        element.textContent = element.getAttribute('data-arrival-by-label') + ' ' + formatted;
      });
    } catch (error) { /* Retain the ten-business-day fallback if dates are unavailable. */ }
  }
  // Shared by the US book sections. Loading this module does not mount an editor.
  if (typeof document !== 'undefined' && document.querySelectorAll) {
    renderUsBookArrivals();
    window.addEventListener('pageshow', renderUsBookArrivals);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) renderUsBookArrivals(); });
  }
  /* Christmas (owner, 2026-10-19): the last weekday to order for delivery by
     22 December, worked back from the page's own arrival window, so it never
     disagrees with the estimate beside it. From 1 October until that day;
     null otherwise. */
  var CHRISTMAS_DELIVERED_BY = 22;
  function christmasOrderBy(today, minDays, maxDays) {
    var custom = minDays > 0 && maxDays >= minDays && Math.floor(minDays) === minDays && Math.floor(maxDays) === maxDays;
    var max = custom ? maxDays : 10;
    // Aim at the 22nd, two working days before Christmas Eve, so a December
    // delay at the printer or carrier still lands before Christmas.
    var eve = new Date(today.getFullYear(), 11, CHRISTMAS_DELIVERED_BY, 12, 0, 0, 0);
    var start = new Date(today.getTime()); start.setHours(12, 0, 0, 0);
    if (start.getMonth() < 9) return null;
    function latest(order) {
      var date = new Date(order.getTime());
      for (var days = 0; days < max;) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) days++; }
      return date;
    }
    var order = new Date(eve.getTime());
    for (var guard = 0; guard < 60; guard++) {
      if (order.getDay() !== 0 && order.getDay() !== 6 && latest(order) <= eve) return order >= start ? order : null;
      order.setDate(order.getDate() - 1);
    }
    return null;
  }
  function steps(offer, count, colouring, pdp, fromSample) {
    // Packages chosen on the product page (2026-09-22): no package screen on
    // the way forward, and a single book is bought from its sample. A set
    // chosen there picks its books straight after the photo (owner,
    // 2026-10-15) and ends there (owner, 2026-10-27): Your books adds the set,
    // with Look inside on each book, and no Check follows. The collection's
    // six fixed books end on Your books too. A set chosen under a single
    // book's sample (owner, 2026-10-18) keeps that sample as its second step,
    // so Back returns to it.
    if (pdp && !colouring) return offer === 'single' ? ['children', 'sample'] : ['children'].concat(fromSample ? ['sample'] : [], ['books']);
    return (colouring ? ['offers', 'children'] : ['children', 'sample', 'offers']).concat(choosesBooks(offer) ? ['books'] : []).concat(!colouring && offer === 'single' ? [] : ['review']);
  }
  /* After "Change package" mid-journey: the first step the new package still
     needs. A single returns to its sample (its purchase step); every set goes
     to Your books (owner, 2026-10-27); on the packages-off journey a set
     without a books step (the collection) carries on to its Check. */
  function afterChange(offer, from) {
    if (from === 'children') return from;
    if (offer === 'single') return 'sample';
    return 'books';
  }
  function ready(child, validName) {
    return Boolean(child && child.ready && !child.checking && child.photoFile && child.consent && validName(child.name));
  }
  /* The photo can wait (owner, 2026-10-19): a valid name is enough to see the
     sample (a person mark stands in for the photo); buying still needs the
     photo and the adult's consent (ready). A photo still being checked holds
     the sample until the check ends. */
  function previewable(child, validName) {
    return Boolean(child && !child.checking && validName(child.name));
  }
  function safeStep(value) { return ['product', 'offers', 'children', 'sample', 'books', 'look', 'review'].indexOf(value) !== -1 ? value : 'product'; }
  /* URL contract: journey steps live at #make/<step>; the product page is the
     plain URL. A #make/product hash (phones surfaced it after exit) always
     means "start the journey", so it routes to child details. #make/look is
     Look inside one chosen book, a view of Your books. */
  function routeStep(hash, colouring) {
    var match = /^#make\/(product|offers|children|sample|books|look|review)$/.exec(hash || '');
    if (!match) return 'product';
    return match[1] === 'product' ? (colouring ? 'offers' : 'children') : match[1];
  }
  function stepUrl(step, pathname, search) { return step === 'product' ? pathname + (search || '') : '#make/' + step; }
  function createModel() {
    var current = 'single', sequence = 0;
    var groups = { single: [PRIMARY] }, assignments = {};
    return {
      offer: function () { return current; },
      ids: function () { return groups[current].slice(); },
      select: function (id) {
        if (['single', 'two-stories', 'two-colouring', 'gift-set', 'complete-collection'].indexOf(id) === -1) return;
        if (id === 'single' || singleChild(id)) groups[id] = [PRIMARY];
        else if (!groups[id]) groups[id] = groups[current].slice(0, 2);
        current = id;
      },
      add: function () {
        var limit = current === 'single' || singleChild(current) ? 1 : 2;
        if (groups[current].length >= limit) return null;
        var id = 'child-' + (++sequence); groups[current].push(id);
        // The pair's second child gets Book 2, so no child is left without a book.
        if (current === 'two-stories') assignments[current] = [PRIMARY, id];
        return id;
      },
      remove: function (id) {
        if (id === PRIMARY) return;
        Object.keys(groups).forEach(function (key) { groups[key] = groups[key].filter(function (value) { return value !== id; }); });
        Object.keys(assignments).forEach(function (key) { assignments[key] = assignments[key].map(function (value) { return value === id ? PRIMARY : value; }); });
      },
      assign: function (index, id) {
        if (singleChild(current)) return;
        if (groups[current].indexOf(id) === -1 || index < 0 || index >= (current === 'gift-set' ? 6 : 2)) return;
        if (!assignments[current]) assignments[current] = [];
        assignments[current][index] = id;
        // Two children share the pair one book each: giving one book away swaps the other.
        if (current === 'two-stories' && groups[current].length === 2) {
          assignments[current][1 - index] = groups[current].filter(function (value) { return value !== id; })[0];
        }
      },
      recipients: function () {
        if (singleChild(current)) return [];
        var ids = groups[current];
        if (current === 'two-stories' && ids.length === 2 && !assignments[current]) assignments[current] = ids.slice();
        return (assignments[current] || []).map(function (id) { return ids.indexOf(id) === -1 ? PRIMARY : id; });
      }
    };
  }
  /* A colouring page has no story stage, so an offer that includes storybooks
     continues on the storybook page's own journey (2026-09-11): same offer
     preselected, child step first, the child carried by the handoff record. */
  function needsStoryHandoff(offer) { return offer === 'two-stories' || offer === 'gift-set' || offer === 'complete-collection'; }
  function storyHandoffUrl(url, offer) { return url + (url.indexOf('?') === -1 ? '?' : '&') + 'bundle=' + encodeURIComponent(offer) + '#make/children'; }
  /* One child per bundle: the book tabs already name story and child, so the
     review rows only exist while a bundle can still name several children. */
  function reviewRows(offer) { return offer !== 'single' && !window.LLBooksOffers.requiresSingleChild(offer); }
  /* A refused Add to basket is marked with the text it showed
     (data-llsb-add-failure). It belongs to that attempt only: Back, Edit photo
     or any other step retires it, so it cannot follow the shopper round the
     page (2026-09-26). Anything written since — a name error, an unconfirmed
     add — no longer matches the marker and stays. */
  function clearAddFailure(node) {
    if (!node || !node.hasAttribute || !node.hasAttribute('data-llsb-add-failure')) return false;
    var shown = node.getAttribute('data-llsb-add-failure') === node.textContent;
    node.removeAttribute('data-llsb-add-failure');
    if (!shown) return false;
    node.hidden = true;
    node.className = 'llsb__upload-status';
    node.textContent = '';
    return true;
  }
  /* The progress row (owner, 2026-10-27): steps before the current one are
     finished and can be gone back to; the current one is marked; the rest
     stay plain. A current step the row does not list leaves every item
     plain, so nothing is ever offered that the shopper has not reached. */
  function progressStates(keys, current) {
    var at = keys.indexOf(current);
    return keys.map(function (key, index) { return at === -1 ? 'todo' : index < at ? 'done' : index === at ? 'current' : 'todo'; });
  }
  /* One progress item, built the same way for every book journey: "<n>. "
     and the label; a finished step with somewhere to go is a button (its
     aria-label carries the number, the label and "done", since phones hide
     the label of finished steps on the five-step row); the current step
     carries aria-current and its optional count. */
  function progressItem(li, item) {
    li.textContent = '';
    li.classList.toggle('is-done', item.state === 'done');
    if (item.state === 'current') li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    var number = item.number ? item.number + '. ' : '';
    var label = document.createElement('span'); label.className = 'llsj-progress__label'; label.textContent = item.label;
    var holder = li;
    if (item.state === 'done' && typeof item.onGo === 'function') {
      holder = document.createElement('button'); holder.type = 'button'; holder.className = 'llsj-progress__link';
      holder.setAttribute('data-llsj-goto', item.key);
      holder.setAttribute('aria-label', number + item.label + ', done');
      holder.addEventListener('click', function () { item.onGo(); });
      li.appendChild(holder);
    }
    if (number) holder.appendChild(document.createTextNode(number));
    holder.appendChild(label);
    if (item.state === 'current' && item.count) li.appendChild(item.count);
  }
  /* Desktop galleries slide between photos (owner 2026-10-05): the photo on
     screen leaves the way the shopper is moving while the next one arrives,
     both over 320ms, inside a stage that clips them meanwhile. The next photo
     is fetched first, so it never slides in blank, and reduced motion swaps
     at once. apply() makes the change; next describes the incoming image. */
  function slidePhoto(stage, image, direction, apply, next) {
    // Only the latest request applies: a quick second click must not be
    // undone by an earlier photo that finished loading later.
    var token = image ? (image.llSlideToken || 0) + 1 : 0;
    if (image) image.llSlideToken = token;
    var still = !direction || !stage || !image || typeof image.animate !== 'function' || !image.complete || !image.naturalWidth || image.hidden || !image.offsetWidth
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still) { apply(); return; }
    var started = false;
    function run() {
      if (started || image.llSlideToken !== token) return;
      started = true;
      var box = stage.getBoundingClientRect(), rect = image.getBoundingClientRect();
      var ghost = document.createElement('img');
      ghost.src = image.currentSrc || image.src; ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true'); ghost.className = 'll-gallery-ghost';
      ghost.style.cssText = 'position:absolute;margin:0;max-width:none;max-height:none;pointer-events:none;left:' + (rect.left - box.left) + 'px;top:' + (rect.top - box.top) + 'px;width:' + rect.width + 'px;height:' + rect.height + 'px';
      stage.classList.add('is-sliding');
      stage.appendChild(ghost);
      apply();
      var distance = Math.round(box.width * 0.5), timing = { duration: 320, easing: 'cubic-bezier(.22,.61,.36,1)' };
      var leave = ghost.animate([{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + (-direction * distance) + 'px)', opacity: 0 }], timing);
      image.animate([{ transform: 'translateX(' + (direction * distance) + 'px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }], timing);
      leave.onfinish = leave.oncancel = function () { ghost.remove(); stage.classList.remove('is-sliding'); };
    }
    if (!next || !next.src) { run(); return; }
    var incoming = new Image();
    if (next.sizes) incoming.sizes = next.sizes;
    if (next.srcset) incoming.srcset = next.srcset;
    incoming.src = next.src;
    if (incoming.complete) run();
    else { incoming.onload = incoming.onerror = run; setTimeout(run, 600); }
  }

  window.LLStorybookJourney = { core: { steps: steps, afterChange: afterChange, arrivalRange: arrivalRange, usBusinessDay: usBusinessDay, usBookArrivalDate: usBookArrivalDate, christmasOrderBy: christmasOrderBy, ready: ready, previewable: previewable, safeStep: safeStep, routeStep: routeStep, stepUrl: stepUrl, createModel: createModel, needsStoryHandoff: needsStoryHandoff, storyHandoffUrl: storyHandoffUrl, reviewRows: reviewRows, clearAddFailure: clearAddFailure, showsPrintableBonus: showsPrintableBonus, progressStates: progressStates }, mount: mount, mountArrival: mountArrival, bindPhotoTips: bindPhotoTips, bindTopbar: bindTopbar, progressItem: progressItem, slidePhoto: slidePhoto };

  /* Photo tips under the upload box (owner, 2026-10-27): open on desktop,
     shut behind "Photo tips" on phones. They follow the screen width until
     the shopper opens or closes them (a click on the summary, which Enter and
     Space also send); from then on the shopper's choice stands. Without
     script the details simply stay shut. */
  function bindPhotoTips(root) {
    var wide = window.matchMedia('(min-width: 990px)');
    root.querySelectorAll('[data-ll-photo-tips]').forEach(function (tips) {
      var chosen = false, summary = tips.querySelector('summary');
      if (summary) summary.addEventListener('click', function () { chosen = true; });
      function follow() { if (!chosen) tips.open = wide.matches; }
      follow();
      wide.addEventListener('change', follow);
    });
  }
  /* The desktop header and progress row stay at the top as the page scrolls;
     once content passes under them they get a bottom edge, so a heading cut
     by the band reads as scrolled, not broken (2026-10-28). */
  function bindTopbar(root) {
    var bars = root.querySelectorAll('.llsj-topbar');
    if (!bars.length) return;
    var frame = 0;
    function sync() {
      frame = 0;
      bars.forEach(function (bar) { bar.classList.toggle('is-stuck', window.scrollY > 0 && bar.offsetParent !== null && bar.getBoundingClientRect().top <= 0); });
    }
    window.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  function mountArrival(root) {
    var arrival = root.querySelector('[data-llsj-arrival]');
    // The Christmas order-by line sits under the arrival estimate (christmasOrderBy).
    var christmas = null, christmasItem = null, leadChristmas = null;
    var calendar = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="5" width="18" height="16" rx="1"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>';
    if (arrival) {
      christmas = document.createElement('span'); christmas.className = 'llsj-christmas'; christmas.setAttribute('data-llsj-christmas', ''); christmas.hidden = true;
      // In a list of benefits it is a line of its own, with a calendar mark.
      var item = arrival.closest('li');
      if (item) {
        christmasItem = document.createElement('li'); christmasItem.className = 'llsj-christmas-item'; christmasItem.hidden = true;
        christmasItem.innerHTML = calendar;
        christmasItem.appendChild(christmas); item.after(christmasItem);
      } else arrival.after(christmas);
      /* Phones (2026-10-20): the same line under the title and review, so the
         date is on the first screen; the list's copy then stays off phones.
         The section holds its line in the season (data-llsj-lead-christmas). */
      var lead = root.querySelector('[data-llsj-lead]');
      if (lead) {
        leadChristmas = lead.querySelector('[data-llsj-lead-christmas]');
        if (!leadChristmas) {
          leadChristmas = document.createElement('p'); leadChristmas.className = 'llsj-lead__christmas'; leadChristmas.hidden = true;
          leadChristmas.appendChild(document.createElement('span')); lead.appendChild(leadChristmas);
        }
        leadChristmas.insertAdjacentHTML('afterbegin', calendar);
      }
    }
    function renderArrival() {
      if (!arrival) return;
      var minDays = parseInt(arrival.getAttribute('data-arrival-min'), 10), maxDays = parseInt(arrival.getAttribute('data-arrival-max'), 10);
      try {
        // US books use the shared holiday-aware date above; keep this
        // weekday-only range for the existing other-market estimates.
        if (!arrival.hasAttribute('data-arrival-static')) {
          var range = document.createElement('span'); range.className = 'llsj-arrival-date';
          range.textContent = arrivalRange(new Date(), minDays, maxDays);
          arrival.replaceChildren(document.createTextNode(arrival.getAttribute('data-label') + ' '), range);
        }
      }
      catch (error) { /* Keep the working-day estimate when date formatting is unavailable. */ }
      try {
        var orderBy = christmasOrderBy(new Date(), minDays, maxDays);
        var us = (root.getAttribute('data-ll-region') || '').toUpperCase() === 'US';
        christmas.hidden = !orderBy;
        if (christmasItem) christmasItem.hidden = !orderBy;
        if (leadChristmas) leadChristmas.hidden = !orderBy;
        if (orderBy) christmas.textContent = (us ? 'Order by ' : 'Order by ') + new Intl.DateTimeFormat(us ? 'en-US' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).format(orderBy) + ' for Christmas';
        if (orderBy && leadChristmas) leadChristmas.lastChild.textContent = christmas.textContent;
      }
      catch (error) { christmas.hidden = true; if (christmasItem) christmasItem.hidden = true; if (leadChristmas) leadChristmas.hidden = true; }
    }
    renderArrival();
    window.addEventListener('pageshow', renderArrival);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) renderArrival(); });
  }

  /* The shop reviews scroll sideways. The arrows move one card, dim at either
     end, and stay hidden while every card already fits. */
  function mountReviewScroller(block) {
    var list = block.querySelector('[data-llsj-reviews-list]');
    var prev = block.querySelector('[data-llsj-reviews-prev]'), next = block.querySelector('[data-llsj-reviews-next]');
    if (!list || !prev || !next) return;
    function sync() {
      var overflow = list.scrollWidth - list.clientWidth;
      prev.hidden = next.hidden = overflow <= 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= overflow - 1;
    }
    function move(direction) {
      var card = list.querySelector('.llsj-reviews__item');
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: direction * ((card ? card.getBoundingClientRect().width : list.clientWidth) + gap), behavior: reduce ? 'auto' : 'smooth' });
      // An instant jump (reduced motion) can land before the list's next scroll event.
      requestAnimationFrame(sync);
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    list.addEventListener('scroll', sync, { passive: true });
    list.addEventListener('scrollend', sync);
    // Also catches the block reappearing when the shopper returns to the product step.
    if (window.ResizeObserver) new ResizeObserver(sync).observe(list);
    else window.addEventListener('resize', sync);
    sync();
  }

  function mount(root, host) {
    var config = host.config, offers = window.LLBooksOffers, bundlePage = window.LLBundlePage;
    if (!offers || !bundlePage || !bundlePage.createChildEditor) return null;
    var copy = config.journeyCopy || {};
    function t(key) { return copy[key] || key.replace(/_/g, ' '); }
    mountArrival(root);
    bindPhotoTips(root);
    // Packages on the product page (2026-09-22): the rows stay on the page,
    // their prices replace the standalone one, and the package screen opens
    // only as a change view ("Change package").
    var offersBlock = root.querySelector('[data-llsj-pdp-offers]');
    var pdp = Boolean(config.pdpOffers) && !config.colouring && Boolean(offersBlock);
    var changeFrom = null, startVisible = false, focusOffers = false;
    root.classList.toggle('llsb--pdp-offers', pdp);
    var model = createModel(), people = {}, editors = {}, panes = {};
    var activeChild = PRIMARY, step = 'product', previewIndex = 0, previewVersion = 0, previewReady = false, sampleSeen = false;
    // Look inside (owner, 2026-10-27) shows one chosen book's pages from Your books.
    function isPreviewStep() { return step === 'review' || step === 'sample' || step === 'look'; }
    function singlePurchaseStep() { return !config.colouring && model.offer() === 'single' && step === (pdp ? 'sample' : 'offers'); }
    function firstStep() { return config.colouring ? 'offers' : 'children'; }
    var hiddenSiblings = [], wasActive = false, lastOffer = '', tabSignature = '';
    var lastFocus = null, returnStep = null, lockedControls = [], completed = false;
    var storageKey = 'llsj:selection:' + config.region + ':' + config.product.handle;
    // llsj--book-list: a story journey, whose preview lists every page full
    // width on desktop too (ll-storybook.js isScrollingBookReader).
    var shell = document.createElement('section'); shell.className = 'llsj llsj--compact' + (config.colouring ? '' : ' llsj--book-list'); shell.hidden = true;
    var header = document.createElement('header'); header.className = 'llsj-header';
    // A step opened from the progress row goes back the way it came, through
    // history, as Finding Me's Back does (2026-10-28); any other step goes
    // back to the step before it.
    var back = button('', 'llp-header__icon llsj-nav llsj-back', function () {
      if (askingFor()) { if (!host.busy()) { if (!mobileCTA.matches) forgetChild(childForBook.id); go('books'); } return; }
      if (linkedFrom()) { if (!host.busy()) history.back(); return; }
      go(previous());
    });
    // Phones show the arrow alone (owner, 2026-10-18), in the header as on
    // Finding Me (owner, 2026-10-28); the word stays for assistive tech and
    // desktop.
    var backLabel = document.createElement('span'); backLabel.className = 'llsj-nav__label'; backLabel.textContent = t('back'); back.appendChild(backLabel);
    var productTitle = config.product.title.split('—')[0].trim();
    var title = document.createElement('span'); title.className = 'llsj-header__title'; title.textContent = productTitle;
    back.prepend(navigationIcon('m14 6-6 6 6 6'));
    var exit = button('', 'llp-header__icon llsj-nav llsj-exit', function () { go('product'); });
    exit.setAttribute('aria-label', t('back_to_product'));
    exit.title = t('back_to_product');
    exit.appendChild(navigationIcon('m6 6 12 12M18 6 6 18'));
    var topbar = document.createElement('div'); topbar.className = 'llsj-topbar'; shell.appendChild(topbar);
    header.appendChild(back); header.appendChild(title); header.appendChild(exit); topbar.appendChild(header);
    var progress = document.createElement('ol'); progress.className = 'llsj-progress'; progress.setAttribute('aria-label', t('progress')); topbar.appendChild(progress);
    bindTopbar(shell);
    // sync() redraws the progress row from scratch, which would drop the focus
    // of a keyboard or screen-reader user resting on a finished-step link (the
    // preview finishing, a status change). The link that has focus is
    // remembered by its step key so sync() can give focus to its new self.
    var progressFocus = null;
    progress.addEventListener('focusin', function (event) { progressFocus = event.target.getAttribute && event.target.getAttribute('data-llsj-goto') || null; });
    progress.addEventListener('focusout', function (event) {
      // Focus moving to another control forgets the link at once. With nowhere
      // to go (the link was removed, or the shopper clicked bare page) it
      // stays remembered only while the link is gone from the page.
      if (event.relatedTarget) { progressFocus = null; return; }
      var left = event.target;
      setTimeout(function () { if (left.isConnected) progressFocus = null; }, 0);
    });
    var notice = document.createElement('p'); notice.className = 'llsj-notice'; notice.setAttribute('role', 'status'); notice.hidden = true; shell.appendChild(notice);
    var screens = {};
    ['offers', 'children', 'sample', 'books', 'look', 'review'].forEach(function (key) {
      var panel = document.createElement('section'); panel.className = 'llsj-screen'; panel.setAttribute('data-llsj-screen', key); panel.hidden = true;
      var heading = document.createElement('h2'); heading.className = 'llp-display llsj-title'; heading.tabIndex = -1;
      heading.textContent = t(key + '_title'); panel.appendChild(heading); screens[key] = panel; shell.appendChild(panel);
    });
    root.appendChild(shell);
    function navigationIcon(path) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.75');
      svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      var shape = document.createElementNS('http://www.w3.org/2000/svg', 'path'); shape.setAttribute('d', path); svg.appendChild(shape);
      return svg;
    }
    function paragraph(parent, key, className) { var p = document.createElement('p'); p.className = className || 'llsj-hint'; p.textContent = t(key); parent.appendChild(p); return p; }
    function button(label, className, action) { var b = document.createElement('button'); b.type = 'button'; b.className = className; b.textContent = label; b.addEventListener('click', action); return b; }
    var summary = root.querySelector('[data-llbo-summary]');
    paragraph(screens.offers, 'offers_hint');
    // One selector, one controller: with product-page packages the change
    // view borrows the rows and hands them back (placeSummary); otherwise
    // they move to the package screen for good.
    var summarySlot = document.createComment('offers');
    if (pdp) summary.parentNode.insertBefore(summarySlot, summary);
    else screens.offers.appendChild(summary);
    var summaryLabel = summary.getAttribute('aria-labelledby');
    function placeSummary() {
      if (!pdp) return;
      if (step === 'offers') { if (summary.parentNode !== screens.offers) screens.offers.appendChild(summary); }
      // Under a single book's sample the rows close the book (morePackages),
      // or sit in the package sheet while it is open.
      else if (morePackages()) { var home = sheetOpen() ? packageSheet.rows : sampleEndRows; if (summary.parentNode !== home) home.appendChild(summary); }
      else if (summary.previousSibling !== summarySlot) summarySlot.parentNode.insertBefore(summary, summarySlot.nextSibling);
      // The group is named by the heading above it wherever it sits.
      var label = summary.parentNode === sampleEndRows ? sampleEndTitle.id : sheetOpen() && summary.parentNode === packageSheet.rows ? packageSheet.heading.id : summaryLabel;
      if (label) summary.setAttribute('aria-labelledby', label); else summary.removeAttribute('aria-labelledby');
    }
    if (!config.colouring && !pdp) summary.querySelectorAll('.llbo-option').forEach(function (option) {
      var row = option.querySelector('.llbo-option__row'), price = row.querySelector('strong');
      var comparison = option.querySelector('.llbo-option__comparison'), oldPrice = comparison && comparison.querySelector('s');
      var prices = document.createElement('span'); prices.className = 'llsj-offer-prices';
      if (oldPrice) prices.appendChild(oldPrice);
      prices.appendChild(price); row.appendChild(prices);
      if (comparison) {
        var saving = comparison.querySelector('span'); comparison.textContent = '';
        if (saving) comparison.appendChild(saving); else comparison.remove();
      }
      if (['gift-set', 'complete-collection'].indexOf(option.getAttribute('data-llbo-option')) !== -1) {
        var name = row.querySelector('.llbo-option__name'), text = name.textContent.trim(), split = text.lastIndexOf(' ');
        if (split > 0) { name.textContent = text.slice(0, split); var line = document.createElement('span'); line.className = 'llsj-offer-name-line'; line.textContent = text.slice(split + 1); name.appendChild(line); }
      }
    });
    var childHint = paragraph(screens.children, 'children_hint', 'llsj-hint llsj-child-instructions');
    var tabs = document.createElement('div'); tabs.className = 'llsj-child-tabs'; tabs.setAttribute('aria-label', t('children')); screens.children.appendChild(tabs);
    var primaryPane = document.createElement('div'); primaryPane.className = 'llsj-child'; primaryPane.setAttribute('data-llsj-child', PRIMARY);
    primaryPane.appendChild(root.querySelector('[data-llsb-step="details"]'));
    primaryPane.appendChild(root.querySelector('[data-llsb-step="character"]'));
    /* The photo can wait (owner, 2026-10-19): say so with the upload; the
       sample is one tap away with the name alone. The line sits under the
       upload box and its message, before the tips, on phones as on desktop
       (2026-10-28), so name and consent read together as on Finding Me. */
    var photoPane = config.colouring ? null : primaryPane.querySelector('[data-llsb-pane="photo"]');
    var photoLater = null;
    if (photoPane) { photoLater = document.createElement('p'); photoLater.className = 'llsj-photo-later'; photoLater.textContent = copy.photo_later || 'A clear photo is needed to order. You can add it at the end.'; photoPane.insertBefore(photoLater, photoPane.querySelector('[data-ll-photo-tips]')); }
    screens.children.appendChild(primaryPane); panes[PRIMARY] = primaryPane;
    var childFields = document.createElement('div'); childFields.className = 'llsj-child-fields';
    if (!config.colouring) {
      screens.children.insertBefore(childFields, tabs);
      childFields.appendChild(childHint); childFields.appendChild(tabs); childFields.appendChild(primaryPane);
    }
    var sameChild = paragraph(screens.children, 'same_child');
    sameChild.classList.add('llsj-same-child');
    /* Another child (the pair, owner 2026-10-24): their own name, tick and
       photo in a tab of their own, and Book 2 is theirs (createModel.add). */
    function addAnotherChild() {
      if (host.busy()) return null;
      var id = model.add(); if (!id) return null;
      people[id] = { id: id, name: '', consent: false, ready: false, photoFile: null };
      var pane = document.createElement('div'); pane.className = 'llsj-child'; pane.setAttribute('data-llsj-child', id);
      sameChild.parentNode.insertBefore(pane, sameChild); panes[id] = pane;
      editors[id] = bundlePage.createChildEditor(pane, people[id], sync);
      if (!config.colouring) alignChildEditor(pane);
      activeChild = id; tabSignature = ''; refreshBundle();
      return id;
    }
    var addChild = button(t('add_child'), 'llsj-link', function () {
      var id = addAnotherChild(); if (!id) return;
      sync(); panes[id].querySelector('input').focus();
    }); addChild.classList.add('llsj-add-child'); screens.children.appendChild(addChild);
    function forgetChild(id) {
      model.remove(id); editors[id].destroy(); panes[id].remove(); delete people[id]; delete panes[id]; delete editors[id];
      activeChild = PRIMARY; tabSignature = ''; refreshBundle();
    }
    var removeChild = button(t('remove_child'), 'llsj-link llsj-remove', function () {
      if (activeChild === PRIMARY || host.busy()) return;
      forgetChild(activeChild); sync(); tabs.querySelector('button').focus();
    }); screens.children.appendChild(removeChild);
    if (!config.colouring) {
      childFields.appendChild(sameChild); childFields.appendChild(addChild); childFields.appendChild(removeChild);
    }
    function alignChildEditor(pane) {
      var label = primaryPane.querySelector('.llsb__field > span');
      pane.querySelector('.llsb__field > span').replaceWith(label.cloneNode(true));
      // Another example name than the first child's.
      pane.querySelector('[data-child-name]').placeholder = 'e.g. ' + (copy.second_child_example || 'Leo');
      var upload = pane.querySelector('.llsb__upload'), consent = pane.querySelector('.llsb__photo-consent');
      consent.querySelector('span').replaceWith(primaryPane.querySelector('.llsb__photo-consent > span').cloneNode(true));
      upload.before(consent, pane.querySelector('[data-child-consent-status]'));
      // Their photo can wait too (syncFinishing words it).
      if (photoLater) { var later = photoLater.cloneNode(false); later.setAttribute('data-llsj-photo-later', ''); consent.before(later); }
    }
    var booksStep = root.querySelector('[data-llbp-books]'); screens.books.appendChild(booksStep);
    if (config.colouring) screens.books.appendChild(button(t('edit_children'), 'llsj-link', function () { returnStep = 'books'; go('children'); }));
    // The free printable sits where a product-page pair ends (showsPrintableBonus).
    var booksBonus = document.createElement('p'); booksBonus.className = 'llbo-option__bonus llsj-books-bonus'; booksBonus.hidden = true; screens.books.appendChild(booksBonus);
    // The set dedication's note, where a product-page set ends (as the Check's order card had it).
    var booksDedication = document.createElement('p'); booksDedication.className = 'llsj-sample-end__dedication llsj-books-dedication'; booksDedication.hidden = true; screens.books.appendChild(booksDedication);
    var booksChange = button(t('change_offer'), 'llsj-link llsj-books-change', function () { changeFrom = step; go('offers'); }); booksChange.hidden = true; screens.books.appendChild(booksChange);
    /* Book 2's Change on Your books adds the pair's second child (the
       configurator's guided.addChild): child details opens on their name and
       Continue comes back. */
    // index: the book whose Change added them, so child details can say who it is for.
    var childForBook = null;
    /* Asked from a book: Continue keeps the new child; desktop's Back, named
       "Same child as Book 1", takes them away again, the book staying with the
       first child. Phones' Back is an unnamed arrow, so it never throws typed
       work away: it goes back to the books, and a child left untouched is
       dropped on the way, as by the browser's Back. No third way out. */
    function askingFor() { return step === 'children' && !finishing && childForBook && activeChild === childForBook.id ? childForBook.index : 0; }
    function addChildForBooks(index) {
      var id = addAnotherChild(); if (!id) return;
      returnStep = 'books'; go('children');
      childForBook = index ? { id: id, index: index } : null; sync();
      var input = panes[id] && panes[id].querySelector('input'); if (input) input.focus();
    }
    var previewHeader = document.createElement('div'); previewHeader.className = 'llsj-preview-header'; screens.review.appendChild(previewHeader);
    var bookTabs = document.createElement('div'); bookTabs.className = 'llsj-book-tabs'; bookTabs.setAttribute('aria-label', t('books')); previewHeader.appendChild(bookTabs);
    function syncTabOverflow() { bookTabs.classList.toggle('has-more', bookTabs.scrollWidth - bookTabs.clientWidth - bookTabs.scrollLeft > 2); }
    bookTabs.addEventListener('scroll', syncTabOverflow, { passive: true });
    window.addEventListener('resize', syncTabOverflow);
    var previewLabel = paragraph(previewHeader, 'story_sample', 'llsj-preview-label');
    var previewStatus = paragraph(screens.review, 'loading_preview', 'llsj-hint'); previewStatus.setAttribute('role', 'status');
    var retry = button(t('retry'), 'llsj-link', loadPreview); retry.hidden = true; screens.review.appendChild(retry);
    var storyHost = document.createElement('div'); storyHost.className = 'llsj-story-preview';
    var livePreview = root.querySelector('[data-llsb-stage-live]'); if (livePreview) storyHost.appendChild(livePreview); screens.review.appendChild(storyHost);
    var coverHost = document.createElement('div'); coverHost.className = 'llsj-cover-preview'; screens.review.appendChild(coverHost);
    var proof = root.querySelector('[data-llsj-proof]');
    if (proof) {
      var upload = primaryPane.querySelector('.llsb__upload');
      // Keep feedback and its return anchor directly after the upload control.
      upload.parentNode.appendChild(proof); proof.hidden = false;
    }
    // Order card: the offer and price, the promise and the change links. It
    // follows the preview in the DOM so phones keep reading top to bottom;
    // desktop places it beside the book under the book rows.
    // Desktop's listed book has no card for one book: the header names the
    // package beside a Change link and the promise sits under the title.
    var samplePromise = paragraph(screens.review, 'preview_email', 'llsj-hint llsj-sample-promise');
    // Under the promise: when the book arrives and that it is checked first.
    var sampleTrust = document.createElement('p'); sampleTrust.className = 'llsj-sample-trust'; screens.review.appendChild(sampleTrust);
    var dedicationApi = host.dedication || null;
    var headerChange = button(t('change_offer'), 'llsj-link llsj-header__change', function () { changeFrom = step; go('offers'); });
    headerChange.hidden = true;
    var titleSignature = '';
    // The listed book (2026-10-13). Its first screen ends under the cover,
    // so a cue above the bar says there is more until the shopper scrolls;
    // the current step counts the page in view ("2. Preview 3 / 15"); and
    // the last page is followed by the book's close: what they have just
    // seen, the same button as the bar, and the delivery estimate.
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scrollCue = button('', 'llsj-scroll-cue', function () {
      var pages = storyHost.querySelectorAll('.llsb-spread');
      var next = pages[1] || pages[0];
      if (next) next.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
    });
    scrollCue.appendChild(document.createTextNode(copy.scroll_cue || 'Scroll to see every page'));
    scrollCue.appendChild(navigationIcon('m6 9 6 6 6-6'));
    scrollCue.hidden = true; shell.appendChild(scrollCue);
    var readCount = document.createElement('span'); readCount.className = 'llsj-progress__count';
    /* Phones scroll the step bar away while reading (2026-10-20): a pill at
       the top counts the page in view, as desktop's bar does, while they
       read, and fades once they stop. Small phones count the pages they
       swipe between; wider phones, like desktop, the spreads. */
    var pagePill = document.createElement('p'); pagePill.className = 'llsj-page-pill'; pagePill.setAttribute('aria-hidden', 'true'); pagePill.hidden = true; shell.appendChild(pagePill);
    var pillTimer = 0;
    function wakePagePill() {
      if (!pagePill.textContent || !shell.classList.contains('llsj--reading')) return;
      pagePill.classList.add('is-awake'); clearTimeout(pillTimer);
      pillTimer = setTimeout(function () { pagePill.classList.remove('is-awake'); }, 1800);
    }
    /* Under a single book's last page (owner, 2026-10-18): the package rows
       again, for a shopper who has just fallen for the sample and wants more.
       No second button: the bar's button follows the row chosen here. A
       set's review and a story sold alone simply end at the last page. */
    var sampleEnd = document.createElement('section'); sampleEnd.className = 'llsj-sample-end llsj-sample-end--more'; sampleEnd.hidden = true; screens.review.appendChild(sampleEnd);
    var sampleEndTitle = document.createElement('h3'); sampleEndTitle.className = 'llp-display llsj-sample-end__title'; sampleEndTitle.id = 'llsj-more-title-' + String(config.product.handle || 'book').replace(/[^a-z0-9-]/gi, ''); sampleEnd.appendChild(sampleEndTitle);
    sampleEnd.setAttribute('aria-labelledby', sampleEndTitle.id);
    var sampleEndNote = document.createElement('p'); sampleEndNote.className = 'llsj-sample-end__note'; sampleEnd.appendChild(sampleEndNote);
    var sampleEndRows = document.createElement('div'); sampleEndRows.className = 'llsj-sample-end__rows'; sampleEnd.appendChild(sampleEndRows);
    var sampleEndDedication = document.createElement('p'); sampleEndDedication.className = 'llsj-sample-end__dedication'; sampleEndDedication.hidden = true; sampleEnd.appendChild(sampleEndDedication);
    var sampleEndTrust = document.createElement('p'); sampleEndTrust.className = 'llsj-sample-end__trust'; sampleEnd.appendChild(sampleEndTrust);
    var packageCount = pdp ? offersBlock.querySelectorAll('[data-llbo-option]').length : 0;
    // A set chosen under the sample keeps it as step 2 (steps(), fromSample).
    var upsold = false;
    /* The story starts the Preview (owner, 2026-10-28): the transformation
       example stays on child details, not above the pages. The sets wait for
       the rows at the end and the package sheet (owner, 2026-10-19: less
       writing above the book, no "Make it a set" link). */
    /* ---- Package sheet (owner, 2026-10-19) ----
       The package rows close a single book's sample, a long scroll down. The
       first press of the bar's button before they were reached opens the same
       rows in a sheet over the preview, and its button then does what the
       bar's would. Reaching the rows, picking one or seeing the sheet once
       means it never asks again. A button only says Add to basket when it
       adds (2026-10-20): until then the bar's reads "Choose books" and the
       sheet's "Continue"; a row picked on the product page skips the sheet. */
    var packagesSeen = false, packageSheet = null;
    function needsPackages() { return morePackages() && model.offer() === 'single' && !packagesSeen; }
    function sheetOpen() { return Boolean(packageSheet && packageSheet.node.hasAttribute('open')); }
    if (pdp && window.IntersectionObserver) new IntersectionObserver(function (entries) {
      if (packagesSeen || step !== 'sample' || sheetOpen() || !entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; })) return;
      packagesSeen = true; sync();
    }, { threshold: [0.5] }).observe(sampleEndRows);
    if (pdp) summary.addEventListener('click', function (event) {
      if (step === 'product' && event.target && event.target.closest && event.target.closest('[data-llbo-option]')) packagesSeen = true;
    });
    function buildPackageSheet() {
      var node = document.createElement('dialog'); node.className = 'llsj-packages';
      var top = document.createElement('div'); top.className = 'llsj-packages__top'; node.appendChild(top);
      var heading = document.createElement('h2'); heading.className = 'llp-display llsj-packages__title'; heading.id = sampleEndTitle.id + '-sheet'; top.appendChild(heading);
      node.setAttribute('aria-labelledby', heading.id);
      var close = button('', 'llsj-packages__close', function () { closePackages(false); });
      close.setAttribute('aria-label', copy.package_sheet_close || 'Close'); close.appendChild(navigationIcon('m6 6 12 12M18 6 6 18')); top.appendChild(close);
      var body = document.createElement('div'); body.className = 'llsj-packages__body'; node.appendChild(body);
      var note = document.createElement('p'); note.className = 'llsj-sample-end__note llsj-packages__note'; body.appendChild(note);
      var rows = document.createElement('div'); rows.className = 'llsj-packages__rows'; body.appendChild(rows);
      var dedication = document.createElement('p'); dedication.className = 'llsj-sample-end__dedication'; dedication.hidden = true; body.appendChild(dedication);
      var foot = document.createElement('div'); foot.className = 'llsj-packages__foot'; node.appendChild(foot);
      var proceed = button('', 'llp-btn llsj-packages__go', function () { closePackages(true); }); foot.appendChild(proceed);
      // Escape closes it like ✕, putting the rows back at the end of the book.
      node.addEventListener('cancel', function (event) { event.preventDefault(); closePackages(false); });
      // However it closed, the rows go back where the step wants them.
      node.addEventListener('close', function () { placeSummary(); sync(); });
      // Inside the journey, so masking the page around it never hides it.
      shell.appendChild(node);
      return { node: node, heading: heading, note: note, rows: rows, dedication: dedication, proceed: proceed, settling: false, settleTimer: 0 };
    }
    function syncPackageSheet() {
      if (!sheetOpen()) return;
      var name = ((children()[0] || {}).name || '').trim();
      packageSheet.heading.textContent = name ? named(copy.package_sheet_title || 'Choose [NAME]’s books', name) : (copy.package_sheet_title_anon || 'Choose your books');
      packageSheet.note.textContent = sampleEndNote.textContent;
      packageSheet.dedication.hidden = sampleEndDedication.hidden; packageSheet.dedication.textContent = sampleEndDedication.textContent;
      // Whatever the row, it carries on: to the basket, or a set's books.
      packageSheet.proceed.textContent = t('continue');
      packageSheet.proceed.disabled = packageSheet.settling || selected().available === false;
    }
    function openPackages() {
      if (host.busy()) return;
      if (!packageSheet) packageSheet = buildPackageSheet();
      packagesSeen = true;
      // Views and the choice carried on from it (closePackages) both use the
      // existing "popup" placement, so the sheet can be measured on its own.
      if (offers && offers.trackOffer) offers.trackOffer('viewed', { region: config.region, surface: 'storybook', offerId: model.offer(), placement: 'popup' });
      // On phones its button sits where the bar's was: a double tap on the
      // bar must not land on it before the rows are seen.
      packageSheet.settling = true; packageSheet.proceed.classList.add('is-settling');
      clearTimeout(packageSheet.settleTimer);
      packageSheet.settleTimer = setTimeout(function () { packageSheet.settling = false; packageSheet.proceed.classList.remove('is-settling'); syncPackageSheet(); }, 450);
      // Hold the space the rows leave, so the page behind does not jump.
      sampleEndRows.style.minHeight = sampleEndRows.offsetHeight + 'px';
      if (typeof packageSheet.node.showModal === 'function') packageSheet.node.showModal(); else packageSheet.node.setAttribute('open', '');
      placeSummary(); syncPackageSheet();
      var chosen = summary.querySelector('[aria-checked="true"]') || summary.querySelector('[role=radio]');
      if (chosen) chosen.focus({ preventScroll: true });
    }
    function hidePackages() {
      if (!sheetOpen()) return false;
      if (typeof packageSheet.node.close === 'function') packageSheet.node.close(); else packageSheet.node.removeAttribute('open');
      sampleEndRows.style.minHeight = '';
      return true;
    }
    // proceed: the sheet's button, which presses the bar's for the row chosen.
    function closePackages(proceed) {
      if (!hidePackages()) return;
      placeSummary(); sync();
      if (proceed) {
        if (offers && offers.trackOffer) offers.trackOffer('selected', { region: config.region, surface: 'storybook', offerId: model.offer(), placement: 'popup' });
        host.press(); return;
      }
      var bar = host.buttons(), target = bar[bar.length - 1];
      if (target) target.focus({ preventScroll: true });
    }
    function named(template, name) { return template.split('[NAME]').join(name); }
    function listedPages() {
      return !config.colouring && isPreviewStep() && previewReady && !storyHost.hidden ? storyHost.querySelectorAll('.llsb-spread') : [];
    }
    function syncReading() {
      var pages = listedPages();
      // Reading down the book, the journey's header slims to one quiet row.
      // Slimming the sticky header moves the page (scroll anchoring shifts
      // scrollY by the height it loses), so it widens again only well above
      // where it slimmed; one threshold made it flicker at the edge.
      var reading = shell.classList.contains('llsj--reading');
      shell.classList.toggle('llsj--reading', pages.length > 0 && window.scrollY > (reading ? 40 : 160));
      var cue = pages.length > 1 && window.scrollY < 60;
      // Above wherever the bar sits: Shopify's cookie banner can lift it.
      if (cue) scrollCue.style.bottom = (window.innerHeight - sticky.getBoundingClientRect().top + 16) + 'px';
      scrollCue.hidden = !cue;
      if (!pages.length) { readCount.textContent = ''; pagePill.textContent = ''; pagePill.hidden = true; return; }
      var middle = window.innerHeight * 0.45, current = 0;
      Array.prototype.forEach.call(pages, function (page, index) { if (page.getBoundingClientRect().top < middle) current = index; });
      // The cover is a page of its own; the spreads count after it.
      var coverFirst = pages[0].classList.contains('llsb-spread--single');
      readCount.textContent = coverFirst && current === 0 ? (copy.reading_cover || 'Front cover')
        : (copy.reading_count || 'Spread [N] of [TOTAL]').replace('[N]', coverFirst ? current : current + 1).replace('[TOTAL]', coverFirst ? pages.length - 1 : pages.length);
      pagePill.textContent = coverFirst && current === 0 ? readCount.textContent : phonePageCount(pages, coverFirst ? 1 : 0, current) || readCount.textContent;
      pagePill.hidden = !shell.classList.contains('llsj--reading');
    }
    /* "Page 7 of 30" while a small phone shows one page of each spread at a
       time; null where whole spreads show. */
    function phonePageCount(pages, first, current) {
      var side = null, before = 0, total = 0;
      for (var i = first; i < pages.length; i++) {
        var pager = pages[i].querySelector('.llsb-spread__pager');
        var paged = Boolean(pager && pager.clientWidth && pager.scrollWidth > pager.clientWidth + 1);
        var count = pages[i].classList.contains('llsb-spread--single') ? 1 : 2;
        if (i === current) { if (!paged && count > 1) return null; side = paged ? (pager.scrollLeft > pager.clientWidth / 2 ? 1 : 0) : 0; }
        if (i < current) before += count;
        total += count;
      }
      return side === null ? null : (copy.reading_page || 'Page [N] of [TOTAL]').replace('[N]', before + side + 1).replace('[TOTAL]', total);
    }
    var readingFrame = 0;
    function onReadingScroll() {
      if (readingFrame) return;
      readingFrame = requestAnimationFrame(function () { readingFrame = 0; syncReading(); wakePagePill(); });
    }
    window.addEventListener('scroll', onReadingScroll, { passive: true });
    // A swipe between a spread's pages scrolls its pager, which does not bubble.
    storyHost.addEventListener('scroll', onReadingScroll, { capture: true, passive: true });
    window.addEventListener('resize', syncReading);
    function arrivalText() {
      var arrival = root.querySelector('[data-llsj-arrival]');
      // One unbreakable phrase, so a date range never wraps mid-way.
      return arrival ? arrival.textContent.trim().replace(/\s+/g, '\u00a0') : '';
    }
    /* Finishing an order whose photo can wait: say what is missing and why. */
    function syncFinishing() {
      if (!photoLater) return;
      // Every child's own line; a pair's second child has one too (alignChildEditor).
      children().forEach(function (child) {
        var note = child.id === PRIMARY ? photoLater : panes[child.id] && panes[child.id].querySelector('[data-llsj-photo-later]');
        if (!note) return;
        var name = (child.name || '').trim();
        // Once their photo is in, the line has nothing left to say (a missing tick has its own message).
        var askPhoto = finishing && activeChild === child.id && !child.photoFile;
        note.hidden = Boolean(child.photoFile);
        note.classList.toggle('is-finishing', askPhoto);
        note.textContent = askPhoto && name ? named(copy.finish_photo || 'We create [NAME]’s character from it for every picture.', name)
          : (copy.photo_later || 'A clear photo is needed to order. You can add it at the end.');
      });
    }
    function syncSampleEnd(child) {
      var name = (child && child.name) || '';
      var show = listedPages().length > 0;
      // Whole phrases, so a wrap never leaves a separator dangling.
      sampleTrust.textContent = '';
      // Above the book only when it arrives (owner, 2026-10-19). Every spread
      // carries its SAMPLE PREVIEW badge and zoom button, so no sample line
      // or tap hint; the order-by date stays on the product page.
      if (!config.colouring && isPreviewStep()) [arrivalText()].filter(Boolean).forEach(function (text) {
        if (sampleTrust.firstChild) sampleTrust.appendChild(document.createTextNode(' '));
        var phrase = document.createElement('span'); phrase.textContent = text; sampleTrust.appendChild(phrase);
      });
      syncPageActions(show);
      sampleEnd.hidden = !show || !morePackages();
      if (sampleEnd.hidden) return;
      sampleEndTitle.textContent = name ? named(copy.sample_more_title || 'Add another book for [NAME]?', name) : (copy.sample_more_title_anon || 'Add another book?');
      // The pair's second story can be for another child (owner, 2026-10-24); the collection is one child.
      var pairOffered = !singleChild('two-stories') && (config.bundles || []).some(function (bundle) { return bundle.id === 'two-stories' && bundle.available; });
      sampleEndNote.textContent = pairOffered
        ? (name ? named(copy.sample_more_note_two || 'Every book uses [NAME]’s photo, or the second story can be for another child.', name) : (copy.sample_more_note_two_anon || 'Every book uses the same photo, or the second story can be for another child.'))
        : name ? named(copy.sample_more_note || 'Every book is made for [NAME] from the same photo.', name) : (copy.sample_more_note_anon || 'Every book is made for the same child from the same photo.');
      // An own dedication is printed in a single book only (the worker reads
      // it from a single book's line); a set keeps the stories' own.
      var ownDedication = dedicationApi && dedicationApi.value(), sets = Boolean(dedicationApi && dedicationApi.sets);
      // Sets print it in every story book once the worker does (sets); Finding books have no dedication page.
      sampleEndDedication.hidden = !ownDedication || model.offer() === 'single' || (sets && model.offer() !== 'complete-collection');
      sampleEndDedication.textContent = sets ? (copy.sample_more_dedication_sets || 'Your dedication goes in every story book. The Finding Me books have no dedication page.')
        : (copy.sample_more_dedication || 'Your own dedication is for a single book. Sets print each story’s dedication.');
      sampleEndTrust.textContent = (copy.sample_end_secure || 'Secure checkout') + (arrivalText() ? ' · ' + arrivalText() : '');
    }
    function morePackages() { return pdp && step === 'sample' && packageCount > 1; }
    /* ---- Buttons on the pages themselves (owner, 2026-10-18, after Wonderbly) ----
       The cover opens child details to change the name or photo (Continue
       comes back here). A single book's dedication page shows our dedication
       as the sample, and "Write a dedication" opens the editor: the sample
       shows the shopper's words at once and the basket line carries them
       (host.dedication). Sets keep each story's own. */
    // A single book's sample, or a set's check step once sets print it (dedicationApi.sets).
    // A set prints one message in every story book, so a pair for two
    // children keeps each story's own dedication, named for its own child.
    // On wherever the order is added from too: Your books ending a set, and the
    // finishing photo step, so a message written in the book is never dropped.
    function dedicationOn() { return (isPreviewStep() || (step === 'books' && booksLast()) || (step === 'children' && finishing)) && (model.offer() === 'single' || (Boolean(dedicationApi && dedicationApi.sets) && !twoChildren())); }
    function twoChildren() {
      var ids = model.recipients();
      return model.offer() !== 'single' && ids.some(function (id) { return id !== ids[0]; });
    }
    function dedicationOffered() { return Boolean(dedicationApi) && !config.colouring && dedicationOn() && dedicationApi.supported(); }
    var pageActions = {};
    function pageAction(key, page, label, action) {
      var node = pageActions[key]; if (!label) page = null;
      if (node && node.parentNode && node.parentNode !== page) { node.parentNode.classList.remove('has-page-action'); node.remove(); }
      if (!page) return;
      if (!node) node = pageActions[key] = button('', 'llsj-page-action', function (event) { event.stopPropagation(); action(node); });
      if (node.textContent !== label) node.textContent = label;
      if (node.parentNode !== page) { page.appendChild(node); page.classList.add('has-page-action'); }
    }
    function syncPageActions(show) {
      if (dedicationApi) dedicationApi.active(Boolean(dedicationApi.value()) && dedicationOn());
      var ready = previewReady && !config.colouring && isPreviewStep();
      // A story's cover spread, or the first page of a Finding book's look inside.
      var cover = !storyHost.hidden ? storyHost.querySelector('.llsb-spread[data-llsb-spread-id="cover"]') : !coverHost.hidden ? coverHost.firstElementChild : null;
      var coverChild = (books()[previewIndex] || {}).child || {};
      var coverLabel = coverChild.photoDataUrl ? (copy.edit_cover || 'Edit name or photo') : named(copy.add_photo || 'Add [NAME]’s photo', coverChild.name || t('child'));
      // The Preview's cover carries no button (owner, 2026-10-28): Back and
      // the "1. Child details" link already go there, and desktop's bar
      // edits the name and photo. The set's Check keeps its cover button.
      pageAction('cover', cover, ready && step !== 'sample' ? coverLabel : '', editChildDetails);
      pageAction('dedication', show ? storyHost.querySelector('.llsb-spread[data-llsb-spread-id="dedication"], .llsb-spread[data-llsb-spread-id="dedication-page"]') : null,
        show && ready && dedicationOffered() ? (dedicationApi.value() ? (copy.dedication_edit || 'Edit dedication') : (copy.dedication_write || 'Write a dedication')) : '', openDedication);
    }
    /* The editor (as Wonderbly's): a page of its own on phones, Cancel at the
       top, the words so far (ours until they change them), what is left, and
       Continue at the foot. Saving ours unchanged keeps ours. */
    var dedicationDialog = null;
    function openDedication(opener) {
      if (!dedicationApi || host.busy()) return;
      if (!dedicationDialog) dedicationDialog = buildDedicationDialog();
      var d = dedicationDialog, child = (books()[previewIndex] || {}).child || {};
      d.heading.textContent = child.name ? named(copy.dedication_title_named || 'Write your own message for [NAME]', child.name) : (copy.dedication_title || 'Write your own message');
      d.field.value = dedicationApi.value() || dedicationApi.standard();
      d.opener = opener;
      d.reset.hidden = !dedicationApi.value();
      d.update();
      if (typeof d.node.showModal === 'function') d.node.showModal(); else d.node.setAttribute('open', '');
      d.field.focus(); d.field.setSelectionRange(d.field.value.length, d.field.value.length);
    }
    function buildDedicationDialog() {
      var node = document.createElement('dialog'); node.className = 'llsj-dedication';
      var form = document.createElement('form'); form.method = 'dialog'; form.className = 'llsj-dedication__form'; node.appendChild(form);
      var top = document.createElement('div'); top.className = 'llsj-dedication__top'; form.appendChild(top);
      var cancel = button(copy.dedication_cancel || 'Cancel', 'llsj-dedication__cancel', function () { close(); }); top.appendChild(cancel);
      var body = document.createElement('div'); body.className = 'llsj-dedication__body'; form.appendChild(body);
      var heading = document.createElement('h2'); heading.className = 'llp-display llsj-dedication__title'; heading.id = sampleEndTitle.id + '-dedication'; body.appendChild(heading);
      node.setAttribute('aria-labelledby', heading.id);
      var help = document.createElement('p'); help.className = 'llsj-dedication__help'; help.id = heading.id + '-help';
      help.textContent = copy.dedication_help || 'Your message goes on the dedication page in place of ours. There’s an 8 line limit (including blank lines), so check how it looks on the page before you order.';
      body.appendChild(help);
      var field = document.createElement('textarea'); field.className = 'llsj-dedication__field'; field.rows = 8; field.maxLength = dedicationApi.maxChars;
      field.setAttribute('aria-describedby', help.id); field.autocomplete = 'off'; field.spellcheck = true; body.appendChild(field);
      var meta = document.createElement('div'); meta.className = 'llsj-dedication__meta'; body.appendChild(meta);
      var error = document.createElement('p'); error.className = 'llsj-dedication__error'; error.setAttribute('role', 'status'); meta.appendChild(error);
      var counter = document.createElement('p'); counter.className = 'llsj-dedication__count'; meta.appendChild(counter);
      var reset = button(copy.dedication_remove || 'Use our dedication', 'llsj-link llsj-dedication__reset', function () { dedicationApi.set(''); close(true); });
      body.appendChild(reset);
      var foot = document.createElement('div'); foot.className = 'llsj-dedication__foot'; form.appendChild(foot);
      var save = document.createElement('button'); save.type = 'submit'; save.className = 'llp-btn llsj-dedication__save'; save.textContent = copy.dedication_save || 'Continue'; foot.appendChild(save);
      var api = { node: node, heading: heading, field: field, reset: reset, opener: null, update: update };
      field.setAttribute('aria-labelledby', heading.id);
      function update() {
        var message = dedicationApi.error(field.value);
        error.textContent = message; error.hidden = !message;
        field.setAttribute('aria-invalid', message ? 'true' : 'false');
        counter.textContent = (copy.dedication_left || '[N] characters left').replace('[N]', Math.max(0, dedicationApi.maxChars - Array.from(field.value).length));
        save.disabled = Boolean(message);
      }
      function close(changed) {
        if (typeof node.close === 'function' && node.open) node.close(); else node.removeAttribute('open');
        if (changed) afterDedication();
        if (api.opener && api.opener.isConnected) api.opener.focus({ preventScroll: true });
      }
      field.addEventListener('input', update);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (dedicationApi.error(field.value)) { update(); return; }
        dedicationApi.set(field.value); close(true);
      });
      // Inside the journey, so masking the page around it never hides it.
      shell.appendChild(node);
      return api;
    }
    /* After a save: the sample shows the words on its dedication page. */
    function afterDedication() {
      sync();
      var page = storyHost.querySelector('[data-llsb-spread-id="dedication"], [data-llsb-spread-id="dedication-page"]');
      if (page) page.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    var orderCard = document.createElement('aside'); orderCard.className = 'llsj-order'; screens.review.appendChild(orderCard);
    var orderLine = document.createElement('p'); orderLine.className = 'llsj-order__line'; orderCard.appendChild(orderLine);
    // A set's own dedication prints in its story books only (Finding books have no dedication page).
    var orderDedication = document.createElement('p'); orderDedication.className = 'llsj-sample-end__dedication llsj-order__dedication'; orderDedication.hidden = true;
    var promise = paragraph(orderCard, 'preview_email', 'llsj-hint llsj-promise');
    orderCard.appendChild(orderDedication);
    var review = document.createElement('div'); review.className = 'llsj-review'; orderCard.appendChild(review);
    // Recovery for an interrupted cart request must remain reachable even
    // after a reload sends the customer back to child details.
    var buy = root.querySelector('.llsb__buy'); root.insertBefore(buy, root.querySelector('.llsb__body'));
    var productPanel = root.querySelector('.llsb__panel');
    var heading = productPanel.querySelector('h1.llsb__heading');
    var headingSlot = document.createComment('heading'); if (heading) heading.parentNode.insertBefore(headingSlot, heading.nextSibling);
    var benefits = root.querySelector('.llsb__benefits'); if (benefits) productPanel.appendChild(benefits);
    var price = document.createElement('p'); price.className = 'llsj-product-price'; price.textContent = config.offers[0].priceFormatted;
    if (config.offers[0].comparePriceFormatted) {
      var formerPrice = document.createElement('s'); formerPrice.textContent = config.offers[0].comparePriceFormatted;
      price.insertBefore(formerPrice, price.firstChild);
    }
    if (!pdp) productPanel.appendChild(price);
    var priceSlot = document.createComment('price'); productPanel.appendChild(priceSlot);
    /* The story pitch and its video link sit right under the title (owner,
       2026-09-23). Phones lift the title above the gallery (placeLead), which
       leaves the pitch first in the panel under it. */
    var pitch = config.colouring ? null : root.querySelector('.llsb__pitch');
    var watchBook = root.querySelector('[data-llsb-watch]');
    // A review line sits between the title and the pitch (owner, 2026-10-19).
    var pitchNodes = [productPanel.querySelector('[data-llsj-review-line]'), pitch, watchBook].filter(Boolean);
    if (heading) headingSlot.after.apply(headingSlot, pitchNodes);
    else pitchNodes.forEach(function (node) { productPanel.appendChild(node); });
    var start = button(t('make_book'), 'llp-btn llsj-start', function () { lastFocus = start; go(firstStep()); }); productPanel.appendChild(start);
    var secure = root.querySelector('[data-llsj-secure]'); if (secure) productPanel.appendChild(secure);
    var howItWorks = root.querySelector('[data-llsj-how]'); if (howItWorks) productPanel.appendChild(howItWorks);
    var productDetails = root.querySelector('[data-llsj-product-details]');
    if (productDetails) productPanel.appendChild(productDetails);
    var reviewSlot = document.createComment('shop reviews');
    var changeNote = null, shopReviews = pdp ? root.querySelector('[data-llsj-pdp-reviews]') : null;
    if (pdp) {
      productPanel.insertBefore(offersBlock, start);
      // A story sold only as a single book has no package to change.
      if (offersBlock.querySelectorAll('[data-llbo-option]').length > 1) {
        changeNote = document.createElement('p'); changeNote.className = 'llsj-offers-pdp__change'; changeNote.textContent = t('pdp_change_note');
        start.after(changeNote);
      }
      // The shop's reviews sit right under the packages: proof at the choice.
      if (shopReviews) { (changeNote || start).after(reviewSlot); reviewSlot.after(shopReviews); mountReviewScroller(shopReviews); }
    }
    /* Phones: the title and price sit above the gallery, so the first screen
       says what the book is and what it costs before the cover fills it.
       Desktop keeps them in the panel beside the gallery. */
    var body = root.querySelector('.llsb__body'), gallery = root.querySelector('.llsb__gallery');
    // The section renders the lead (with a copy of the title) when packages
    // are on the page, so phones paint it before this script runs.
    var lead = root.querySelector('[data-llsj-lead]');
    if (!lead) {
      lead = document.createElement('div'); lead.className = 'llsj-lead'; lead.hidden = true;
      if (body && gallery) body.insertBefore(lead, gallery);
    }
    function placeLead(mobile) {
      if (!heading || !body) return;
      if (mobile) {
        var copy = lead.querySelector('[data-llsj-lead-copy]'); if (copy) copy.remove();
        lead.insertBefore(heading, lead.querySelector('[data-llsj-review-line]')); if (!pdp) lead.insertBefore(price, lead.querySelector('.llsj-lead__christmas')); lead.hidden = false;
      }
      else { productPanel.insertBefore(heading, headingSlot); if (!pdp) productPanel.insertBefore(price, priceSlot); lead.hidden = true; }
      root.classList.remove('llsj-lead-pending');
      placeWatch(mobile);
    }
    /* Phones (2026-10-20): the video button sits right under the gallery,
       above the pitch, so the purchase bar never covers it on the first
       screen. Desktop keeps it under the pitch. Moved only when out of place. */
    function placeWatch(mobile) {
      if (!watchBook || !pitch || watchBook.parentNode !== pitch.parentNode) return;
      if (mobile && watchBook.nextElementSibling !== pitch) pitch.before(watchBook);
      else if (!mobile && pitch.nextElementSibling !== watchBook) pitch.after(watchBook);
    }
    /* Desktop (owner, 2026-09-23): How it works and the product details sit
       under the gallery, so the images no longer head an empty column while
       the panel carries everything; the panel keeps the purchase. Phones keep
       one column with both at the panel's end. */
    var detailNodes = config.colouring ? [] : [howItWorks, productDetails].filter(Boolean);
    var detailsColumn = document.createElement('div'); detailsColumn.className = 'llsj-details'; detailsColumn.hidden = true;
    if (detailNodes.length && body && gallery) gallery.after(detailsColumn);
    function placeDetails(mobile) {
      if (!detailsColumn.parentNode) return;
      var parent = mobile ? productPanel : detailsColumn;
      // Move only when out of place: re-inserting a focused node blurs it.
      var inPlace = parent.lastElementChild === detailNodes[detailNodes.length - 1]
        && detailNodes.every(function (node, i) { return !i || detailNodes[i - 1].nextElementSibling === node; });
      if (!inPlace) detailNodes.forEach(function (node) { parent.appendChild(node); });
      detailsColumn.hidden = mobile;
      root.classList.toggle('llsb--details-column', !mobile);
    }
    var sticky = document.querySelector('[data-llsb-ctabar]'); sticky.classList.add('llsb__ctabar--journey');
    var mobileCTA = window.matchMedia('(max-width: 989px)');
    // Measure the surrounding UI so landscape also fits longer titles,
    // market prices and the purchase bar's safe-area padding.
    var crumbs = root.querySelector('.llsb__crumbs-row');
    function syncGalleryClearance() {
      var reserved = [lead, crumbs, sticky].reduce(function (height, element) {
        return height + (element ? element.getBoundingClientRect().height : 0);
      }, 12);
      root.style.setProperty('--llsj-gallery-reserved-height', Math.ceil(reserved) + 'px');
    }
    if (window.ResizeObserver) {
      var galleryClearanceObserver = new ResizeObserver(syncGalleryClearance);
      [lead, crumbs, sticky].filter(Boolean).forEach(function (element) { galleryClearanceObserver.observe(element); });
    }
    window.addEventListener('resize', syncGalleryClearance);
    syncGalleryClearance();
    /* Shopify's consent banner pins over the bottom of the viewport; while it
       is open the fixed bar would float mid-screen over the cover, so on the
       product step the in-flow button stands in for it until the banner goes. */
    function consentBannerOpen() {
      var clearance = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--llsb-consent-clearance'));
      return isFinite(clearance) && clearance > 0;
    }
    /* Desktop product pages (owner, 2026-09-23, after Wonderbly): the chosen
       package's price rides in Make my book, right under the packages. */
    var startPrice = '';
    function syncStartLabel(mobile) {
      var label = t('make_book') + (pdp && !mobile && startPrice ? ' · ' + startPrice : '');
      if (start.textContent !== label) start.textContent = label;
    }
    /* Back stays in the header at every width (owner, 2026-10-28): phones
       show its arrow, as Finding Me's do, and the bar keeps only its button.
       The 2026-10-18 named link under the bar's button repeated it. Asked
       from a book, Back takes the new child away again and is named for it. */
    function placeBack() {
      back.hidden = step === 'product';
      var text = askingFor() && !mobileCTA.matches ? copy.same_child_book || 'Same child as Book 1' : t('back');
      if (backLabel.textContent !== text) backLabel.textContent = text;
    }
    function syncProductCTA() {
      var mobile = mobileCTA.matches, consentOpen = step === 'product' && consentBannerOpen();
      start.hidden = mobile && !consentOpen;
      // Desktop product pages with packages: the bar stands in for the panel
      // button while it is off screen, so the purchase never leaves view.
      sticky.hidden = step === 'product' && (consentOpen || (!mobile && (!pdp || startVisible)));
      // The colouring page (being retired) keeps Back in its header.
      placeLead(mobile); placeDetails(mobile); syncStartLabel(mobile); placeBack();
    }
    // A button cut off by the window edge still needs the bar. Seeded from
    // layout so the desktop bar does not flash before the first callback.
    if (pdp) { var startBox = start.getBoundingClientRect(); startVisible = startBox.height > 0 && startBox.top >= 0 && startBox.bottom <= window.innerHeight; }
    if (pdp && window.IntersectionObserver) new IntersectionObserver(function (entries) {
      startVisible = entries[entries.length - 1].intersectionRatio >= 0.98; syncProductCTA();
    }, { threshold: [0, 0.98, 1] }).observe(start);
    /* One tap on Make my book starts (owner, 2026-10-19). The 2026-09-22
       first-tap reveal of the package rows is gone: the rows stay on the
       product page and close a single book's sample. */
    if (mobileCTA.addEventListener) mobileCTA.addEventListener('change', syncProductCTA);
    else mobileCTA.addListener(syncProductCTA);
    if (window.MutationObserver) new MutationObserver(function () { syncProductCTA(); }).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    var total = document.createElement('div'); total.className = 'llsj-total'; sticky.insertBefore(total, sticky.firstChild);
    var quickEdit = document.createElement('div'); quickEdit.className = 'llsj-quick-edit'; quickEdit.hidden = true;
    var quickLabel = document.createElement('label'); quickLabel.className = 'llsj-quick-name';
    var quickCaption = document.createElement('span'); quickCaption.className = 'llsj-quick-caption'; quickCaption.textContent = 'Child’s name';
    var quickAction = document.createElement('span'); quickAction.className = 'llsj-quick-action'; quickAction.textContent = 'Edit'; quickAction.setAttribute('aria-hidden', 'true'); quickCaption.appendChild(quickAction); quickLabel.appendChild(quickCaption);
    var quickName = document.createElement('input'); quickName.type = 'text'; quickName.maxLength = 12;
    quickName.autocomplete = 'off'; quickName.setAttribute('aria-label', 'Child’s name'); quickName.setAttribute('data-llsj-edit-name', ''); quickLabel.appendChild(quickName);
    quickEdit.appendChild(quickLabel);
    function editChildDetails() {
      var book = books()[previewIndex]; if (!book) return;
      activeChild = book.child.id; returnStep = isPreviewStep() ? step : 'review'; go('children');
      focusPhoto();
    }
    function focusPhoto() {
      var photoField = panes[activeChild] && panes[activeChild].querySelector('input[type=file]');
      if (photoField) { photoField.focus({ preventScroll: true }); photoField.closest('.llsb__upload').scrollIntoView({ block: 'nearest' }); }
    }
    var quickPhoto = button('Edit photo', 'llsj-quick-photo', editChildDetails);
    quickPhoto.setAttribute('aria-label', 'Edit photo'); quickPhoto.textContent = '';
    var quickPhotoCopy = document.createElement('span'); quickPhotoCopy.className = 'llsj-quick-photo-copy';
    var quickPhotoCaption = document.createElement('span'); quickPhotoCaption.className = 'llsj-quick-caption'; quickPhotoCaption.textContent = 'Child’s photo'; quickPhotoCopy.appendChild(quickPhotoCaption);
    var quickPhotoAction = document.createElement('span'); quickPhotoAction.className = 'llsj-quick-action'; quickPhotoAction.textContent = 'Edit photo'; quickPhotoCopy.appendChild(quickPhotoAction); quickPhoto.appendChild(quickPhotoCopy);
    var quickPhotoImage = document.createElement('img'); quickPhotoImage.alt = ''; quickPhoto.prepend(quickPhotoImage); quickEdit.appendChild(quickPhoto);
    /* A story's Preview names its child in one chip, as Finding Me's Look
       inside does (2026-10-28, A9 round 3): photo, name and one Edit, which
       opens child details, where both are. The colouring page and a set's
       Check keep the name field and the photo button. */
    var quickChip = button('', 'llsj-quick-chip', editChildDetails); quickChip.hidden = true;
    quickChip.setAttribute('aria-label', copy.edit_cover || 'Edit name or photo');
    var quickChipImage = document.createElement('img'); quickChipImage.alt = ''; quickChip.appendChild(quickChipImage);
    var quickChipCopy = document.createElement('span'); quickChipCopy.className = 'llsj-quick-chip__copy';
    var quickChipCaption = document.createElement('small'); quickChipCaption.textContent = 'Your book'; quickChipCopy.appendChild(quickChipCaption);
    var quickChipName = document.createElement('strong'); quickChipCopy.appendChild(quickChipName); quickChip.appendChild(quickChipCopy);
    var quickChipAction = document.createElement('span'); quickChipAction.className = 'llsj-quick-action'; quickChipAction.textContent = 'Edit'; quickChip.appendChild(quickChipAction);
    quickEdit.appendChild(quickChip);
    var quickError = document.createElement('p'); quickError.className = 'llsj-quick-error'; quickError.id = 'llsj-quick-name-error';
    quickError.setAttribute('role', 'status'); quickError.hidden = true; quickEdit.appendChild(quickError);
    quickName.setAttribute('aria-describedby', quickError.id);
    sticky.insertBefore(quickEdit, total);
    quickName.addEventListener('input', function () {
      var book = books()[previewIndex]; if (!book || host.busy()) return;
      var source = panes[book.child.id].querySelector(book.child.id === PRIMARY ? '[data-llsb-name], [data-llcb-name]' : '[data-child-name]');
      source.value = quickName.value; source.dispatchEvent(new Event('input', { bubbles: true }));
      var valid = offers.validName(quickName.value.trim());
      quickName.setAttribute('aria-invalid', valid ? 'false' : 'true');
      quickError.textContent = valid ? '' : 'Please enter a first name using up to 12 letters.'; quickError.hidden = valid;
      refreshBundle(); renderReview();
      var updated = books()[previewIndex];
      if (updated && !updated.colouring && host.updatePreviewChild) {
        host.updatePreviewChild(updated.child); renderPreviewLabel(updated);
      } else if (valid) loadPreview();
      sync();
    });
    quickName.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); quickName.blur(); } });
    function syncQuickEdit() {
      quickEdit.hidden = !isPreviewStep() || step === 'look';
      if (quickEdit.hidden) return;
      var book = books()[previewIndex]; if (!book) return;
      var oneChip = !config.colouring && step === 'sample';
      quickEdit.classList.toggle('llsj-quick-edit--chip', oneChip);
      quickLabel.hidden = oneChip; quickPhoto.hidden = oneChip; quickChip.hidden = !oneChip;
      if (document.activeElement !== quickName) quickName.value = book.child.name || '';
      quickChipName.textContent = book.child.name || '';
      quickPhotoImage.src = book.child.photoDataUrl || ''; quickPhotoImage.hidden = !book.child.photoDataUrl;
      quickChipImage.src = book.child.photoDataUrl || ''; quickChipImage.hidden = !book.child.photoDataUrl;
      quickName.disabled = host.busy() || !previewReady; quickPhoto.disabled = quickName.disabled; quickChip.disabled = quickName.disabled;
      if (offers.validName(book.child.name)) { quickError.hidden = true; quickName.removeAttribute('aria-invalid'); }
    }

    root.classList.add('llsb--guided');
    if (window.visualViewport) {
      // Lift the bar only above an on-screen keyboard. Android Chrome resizes the
      // visual viewport as its toolbar comes and goes while scrolling, which
      // used to float the bar up the page (owner, 2026-10-19), so the gap
      // counts only while a text field has focus and is keyboard-sized.
      var typing = function () {
        var active = document.activeElement;
        return Boolean(active && (active.tagName === 'TEXTAREA' || active.isContentEditable || (active.tagName === 'INPUT' && /^(text|search|email|tel|number|url|password)$/.test(active.type || 'text'))));
      };
      var fitKeyboard = function () {
        var gap = typing() ? Math.max(0, innerHeight - window.visualViewport.height - window.visualViewport.offsetTop) : 0;
        document.documentElement.style.setProperty('--llsj-keyboard-clearance', (gap >= 120 ? gap : 0) + 'px');
      };
      window.visualViewport.addEventListener('resize', fitKeyboard);
      document.addEventListener('focusin', fitKeyboard);
      document.addEventListener('focusout', function () { setTimeout(fitKeyboard, 0); });
      fitKeyboard();
    }
    var more = root.querySelector('[data-llsb-more]');
    var readingBenefits = root.querySelector('[data-llsj-reading-benefits]');
    var addStatus = buy.querySelector('[data-llsb-add-status]');
    if (addStatus && window.MutationObserver) new MutationObserver(function () { sync(); }).observe(addStatus, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });

    function children() {
      people[PRIMARY] = Object.assign({ id: PRIMARY }, host.primary());
      return model.ids().map(function (id) { return people[id]; });
    }
    function firstInvalid() {
      var list = children();
      for (var i = 0; i < list.length; i++) if (!ready(list[i], offers.validName)) return list[i];
      return null;
    }
    // The first child who cannot be previewed yet (no valid name, photo mid-check).
    function firstUnpreviewable() {
      var list = children();
      for (var i = 0; i < list.length; i++) if (!previewable(list[i], offers.validName)) return list[i];
      return null;
    }
    /* Add to basket pressed before the photo (or consent) is in: child
       details opens on the photo, and its button finishes the order. */
    var finishing = false;
    function currentSteps() { return steps(model.offer(), model.ids().length, Boolean(config.colouring), pdp, upsold); }
    // A story's photo step: shown until every child's photo and tick are in.
    function photoStepShown(list, onIt) {
      return !config.colouring && (onIt || list.some(function (child) { return !ready(child, function () { return true; }); }));
    }
    // The step a finished-step link was pressed on, while the shopper is on
    // the step it opened (its history entry records both).
    function linkedFrom() {
      var entry = history.state;
      return entry && entry.llsjFrom && entry.llsjTo === step ? entry.llsjFrom : null;
    }
    function previous() {
      if (pdp && step === 'offers') return changeFrom || 'product';
      if (step === 'look') return 'books';
      if (linkedFrom()) return linkedFrom();
      // Child details opened from a sample (an edit, or finishing the order) goes back to it.
      if (step === 'children' && returnStep) return returnStep;
      var list = ['product'].concat(currentSteps()); return list[Math.max(0, list.indexOf(step) - 1)];
    }
    function refreshBundle() { var api = host.bundle(); if (api && model.offer() !== 'single') api.render(); }
    // Your books is a set's last step on the product-page journey (owner, 2026-10-27).
    function booksLast() { var list = currentSteps(); return list[list.length - 1] === 'books'; }
    // Book 1's child, whoever the pair's two children are (the printable is theirs, #736).
    function bookOneChild() { var api = host.bundle(), state = api && api.state(); return state ? bundlePage.core.slotChild(state, state.slots[0]) : children()[0]; }
    function emptySlot() { var api = host.bundle(); return Boolean(api && api.state().slots.some(function (slot) { return !slot.storyId; })); }
    function selected() { return model.offer() === 'single' ? config.offers[0] : (config.bundles || []).filter(function (b) { return b.id === model.offer(); })[0]; }
    function books() {
      if (model.offer() === 'single' || step === 'sample') return [{ storyId: config.colouring ? config.storyBookId : config.storyId, title: config.colouring ? config.product.title : config.offers[0].title, url: config.product.url, child: children()[0], colouring: Boolean(config.colouring), index: 0 }];
      var api = host.bundle(); if (!api) return [];
      var state = api.state(), core = bundlePage.core, list = [];
      state.slots.forEach(function (slot, i) {
        // A slot still to choose in the picker has no book to show.
        if (!slot.storyId) return;
        var entry = (model.offer() === 'two-colouring' ? config.catalogue.colouring : config.catalogue.stories).filter(function (s) { return s.storyId === slot.storyId; })[0];
        list.push(Object.assign({}, entry, { child: core.slotChild(state, slot), colouring: model.offer() === 'two-colouring', index: i }));
      });
      if (model.offer() === 'gift-set') state.slots.forEach(function (slot, i) {
        var entry = offers.collectionColouring(config.catalogue, slot, state.slots);
        list.push(Object.assign({}, entry, { child: core.colouringChild(state, slot), colouring: true, index: i }));
      });
      return list;
    }
    /* Hides everything around the journey while it is open. Each sibling is
       handled on its own and read through getAttribute: a <form> holding a
       control named "id" reports that control as form.id, and a page-level
       element like that (seen on a phone, 2026-09-11) used to throw here
       half-way through go(), leaving the shell open with no step rendered. */
    function maskPage(active) {
      if (active === wasActive) return;
      wasActive = active;
      if (!active) {
        hiddenSiblings.forEach(function (row) {
          try { row.node.hidden = row.hidden; row.node.inert = row.inert; row.node.classList.remove('llsj-masked'); } catch (error) { /* an element we could not mask cannot block the exit */ }
        });
        hiddenSiblings = []; return;
      }
      var node = root;
      while (node.parentElement && node !== document.body) {
        Array.prototype.forEach.call(node.parentElement.children, function (sibling) {
          try {
            if (sibling === node || sibling === sticky || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName) || String(sibling.getAttribute('id') || '').indexOf('shopify-pc') === 0) return;
            var row = { node: sibling, hidden: sibling.hidden, inert: sibling.inert };
            sibling.hidden = true; sibling.inert = true; sibling.classList.add('llsj-masked');
            hiddenSiblings.push(row);
          } catch (error) { /* one hostile element must never blank the journey */ }
        });
        node = node.parentElement;
      }
    }
    // A package deselected on the product page must not return from its old
    // ?bundle= link when the page is refreshed.
    function dropStaleBundleParam() {
      if (!pdp) return;
      try {
        var url = new URL(location.href), linked = url.searchParams.get('bundle');
        if (!linked || linked === model.offer()) return;
        url.searchParams.delete('bundle');
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      } catch (error) { /* keep the link; a refresh may reapply it */ }
    }
    function storeSelection() {
      if (completed) return;
      try {
        var api = host.bundle();
        sessionStorage.setItem(storageKey, JSON.stringify({ version: 1, expires: Date.now() + 3600000, offer: model.offer(), stories: api && model.offer() !== 'single' ? api.state().slots.map(function (s) { return s.storyId; }) : [] }));
      } catch (error) { /* Navigation works with storage denied. No child data is stored. */ }
    }
    // from: the step a finished-step link was pressed on (linkedFrom).
    /* A second child added and left untouched (no name, no photo) is taken
       away when the shopper leaves child details another way than Continue,
       so Back and the progress row never stay stuck on their empty fields. */
    function dropUntouchedChildren() {
      model.ids().forEach(function (id) {
        var person = people[id];
        if (id === PRIMARY || !person || person.name || person.photoFile || person.checking) return;
        model.remove(id); if (editors[id]) editors[id].destroy(); if (panes[id]) panes[id].remove();
        delete people[id]; delete panes[id]; delete editors[id];
        if (activeChild === id) activeChild = PRIMARY;
        tabSignature = ''; refreshBundle();
      });
    }
    function go(requested, replace, from) {
      var target = safeStep(requested);
      if (host.busy() && step !== 'product') { history.replaceState(null, '', stepUrl(step, location.pathname, location.search)); return; }
      if (step === 'children' && target !== 'children') dropUntouchedChildren();
      // With product-page packages the package screen is a change view that
      // opens only from "Change package"; any other way in (the homepage
      // hero, an old link) lands on the product page's own rows.
      if (pdp && target === 'offers' && !changeFrom) { target = 'product'; focusOffers = true; }
      if (target === 'review' && pdp && !config.colouring && model.offer() !== 'single') target = 'books';
      // Look inside needs a chosen book on a journey that ends on Your books.
      if (target === 'look' && (!booksLast() || !host.bundle() || !host.bundle().state().slots.some(function (slot) { return slot.storyId; }))) target = 'books';
      if ((target === 'books' || target === 'look' || target === 'review' || target === 'sample' || (!config.colouring && !pdp && target === 'offers')) && firstUnpreviewable()) target = 'children';
      if (config.colouring && target === 'sample') target = 'review';
      // A product-page set has no sample step: an old #make/sample opens its
      // books, or the collection's review (it has no books step).
      if (target === 'sample' && currentSteps().indexOf('sample') === -1) target = currentSteps().indexOf('books') !== -1 ? 'books' : 'review';
      if (!config.colouring && !sampleSeen && currentSteps().indexOf('sample') !== -1 && ['books', 'look', 'review'].concat(pdp ? [] : ['offers']).indexOf(target) !== -1) target = 'sample';
      if (target === 'sample' && firstUnpreviewable()) target = 'children';
      if (target === 'books' && currentSteps().indexOf('books') === -1) target = 'review';
      // A set with a book still to choose is never checked with an empty slot.
      if (target === 'review' && currentSteps().indexOf('books') !== -1 && emptySlot()) target = 'books';
      if (target === 'review' && !config.colouring && model.offer() === 'single') target = pdp ? 'sample' : 'offers';
      if (target !== 'offers') changeFrom = null;
      if (target === 'product') upsold = false;
      if (target !== 'children') { finishing = false; childForBook = null; }
      clearAddFailure(addStatus);
      host.cancelPreview();
      hidePackages();
      step = target; if (step === 'offers') { completed = false; packagesSeen = true; } previewVersion++; previewReady = false;
      placeSummary();
      if (target !== 'children') returnStep = null;
      shell.hidden = step === 'product'; root.querySelector('.llsb__body').hidden = step !== 'product'; if (more) more.hidden = step !== 'product'; if (readingBenefits) readingBenefits.hidden = step !== 'product';
      root.setAttribute('data-llsj-step', step);
      root.classList.toggle('llsb--compact-form', !config.colouring && step !== 'product' && !isPreviewStep());
      try { maskPage(step !== 'product'); } catch (error) { /* the step must render even if the page around it cannot be masked */ }
      Object.keys(screens).forEach(function (key) { screens[key].hidden = key !== step; });
      // Bundle product links open child details directly. Keep the shop proof
      // visible there, then restore its purchase-panel position on exit.
      if (shopReviews) {
        var directBundle = offers.requestedBundleId && offers.requestedBundleId() && model.offer() !== 'single';
        if (directBundle && step === 'children') screens.children.appendChild(shopReviews);
        else if (shopReviews.parentNode !== productPanel) reviewSlot.after(shopReviews);
      }
      if (step === 'books') { booksStep.hidden = false; refreshBundle(); }
      var url = stepUrl(step, location.pathname, location.search);
      // The change view remembers where it came from, so Forward can reopen it.
      var entry = step === 'offers' && changeFrom ? { llsjChangeFrom: changeFrom } : from && from !== step ? { llsjFrom: from, llsjTo: step } : null;
      if (!replace) history.pushState(entry, '', url);
      // Only a #make/ hash is ever rewritten: other anchors on the product page are left alone.
      else if (/^#make\//.test(location.hash) && location.hash !== url) history.replaceState(entry, '', url);
      sync();
      // Every entry the shopper reaches drops a bundle link they have since deselected.
      dropStaleBundleParam();
      if (isPreviewStep()) {
        [samplePromise, sampleTrust, previewHeader, previewStatus, retry, storyHost, coverHost, sampleEnd, orderCard].forEach(function (node) { if (node) screens[step].appendChild(node); });
        if (step === 'sample') previewIndex = 0;
        renderReview(); loadPreview();
      }
      window.scrollTo(0, 0);
      if (step !== 'product') screens[step].querySelector('h2').focus({ preventScroll: true });
      else if (lastFocus) {
        // The colouring page's bar button is [data-llcb-add-sticky].
        var returnTo = mobileCTA.matches ? sticky.querySelector('[data-llsb-add-sticky], [data-llcb-add-sticky]') : start;
        if (returnTo) returnTo.focus({ preventScroll: true });
      }
      if (step === 'product' && focusOffers) {
        focusOffers = false;
        var chosen = summary.querySelector('[aria-checked="true"]') || summary.querySelector('[role=radio]');
        offersBlock.scrollIntoView({ block: 'center' });
        if (chosen) chosen.focus({ preventScroll: true });
      }
    }
    function sync() {
      var currentOffer = host.offer();
      if (currentOffer !== model.offer()) {
        // A set picked under the single book's sample (morePackages).
        if (morePackages() && currentOffer !== 'single') upsold = true;
        if (morePackages()) packagesSeen = true;
        model.select(currentOffer); activeChild = PRIMARY; previewIndex = 0;
      }
      var list = children(), ids = model.ids(), selectedOffer = selected();
      var shared = singleChild(model.offer());
      if (shared || model.offer() === 'single') {
        addChild.remove(); removeChild.remove(); tabs.remove();
        Object.keys(editors).forEach(function (id) {
          editors[id].destroy(); delete editors[id]; panes[id].remove();
          if (people[id].checking) { people[id].checking = false; people[id].ready = false; }
        });
      } else {
        primaryPane.before(tabs); sameChild.after(addChild, removeChild);
        ids.forEach(function (id) {
          if (id === PRIMARY || editors[id]) return;
          sameChild.before(panes[id]);
          editors[id] = bundlePage.createChildEditor(panes[id], people[id], sync);
          if (!config.colouring) alignChildEditor(panes[id]);
        });
      }
      if (list.every(function (child) { return previewable(child, offers.validName); })) notice.hidden = true;
      var signature = ids.map(function (id, i) { return id + ':' + (list[i].name || ''); }).join('|') + ':' + activeChild;
      if (signature !== tabSignature) {
        tabSignature = signature; tabs.textContent = '';
        list.forEach(function (child, i) {
          var b = button(child.name || t('child') + ' ' + (i + 1), 'llsj-child-tab', function () { activeChild = child.id; tabSignature = ''; sync(); tabs.querySelector('[aria-pressed=true]').focus(); });
          b.setAttribute('aria-pressed', child.id === activeChild ? 'true' : 'false'); tabs.appendChild(b);
        });
      }
      tabs.hidden = ids.length < 2;
      Object.keys(panes).forEach(function (id) { panes[id].hidden = id !== activeChild || ids.indexOf(id) === -1; });
      sameChild.hidden = shared || model.offer() === 'single' || ids.length > 1;
      addChild.hidden = shared || ids.length >= (model.offer() === 'single' ? 1 : 2);
      removeChild.hidden = activeChild === PRIMARY;
      progress.textContent = '';
      // The photo waits for Add to basket, so the bar names it as the last
      // step after child details (2026-10-20): no surprise step at the end.
      // It goes once every photo is in, unless they are on it, so a step ahead
      // of the shopper never reads as done (2026-10-28). Child details itself
      // never shows it (2026-10-28, A9 round 3): the upload box is on screen
      // and the line under it says the photo can wait, and the row keeps its
      // shape when a photo is accepted. Finishing (Add to basket before the
      // photo) is that step, never child details again.
      var finishingPhoto = step === 'children' && finishing;
      // Look inside is a view of Your books, which stays the current step under it.
      var barSteps = currentSteps().concat((step !== 'children' || finishingPhoto) && photoStepShown(list, finishingPhoto) ? ['photo'] : []);
      var progressStep = finishingPhoto ? 'photo' : step === 'look' ? 'books' : step;
      progress.classList.toggle('llsj-progress--long', barSteps.length > 4);
      // Finished steps are links back to them (owner, 2026-10-27), on phones'
      // Preview too, beside the bar's named Back. The photo is not a screen
      // of its own, and the step already on screen goes nowhere.
      var states = progressStates(barSteps, progressStep);
      barSteps.forEach(function (key, index) {
        var li = document.createElement('li');
        progressItem(li, { key: key, number: index + 1, label: key === 'photo' ? copy.photo_step || 'Photo' : t(key + '_step'), state: states[index], count: key === progressStep && isPreviewStep() && step !== 'look' ? readCount : null, onGo: key === 'photo' || key === step ? null : function () { go(key, false, step); } });
        progress.appendChild(li);
      });
      // A finished-step link that had focus gets it back on its rebuilt self,
      // unless focus has gone to some other control meanwhile.
      if (progressFocus) {
        var lostFocus = !document.activeElement || document.activeElement === document.body || !document.contains(document.activeElement);
        var sameLink = lostFocus && progress.querySelector('[data-llsj-goto="' + progressFocus + '"]');
        progressFocus = null;
        if (sameLink) sameLink.focus({ preventScroll: true });
      }
      // A pair picked under the sample keeps that story as book 1; only the second is chosen (owner, 2026-10-19).
      var secondOnly = upsold && model.offer() === 'two-stories';
      shell.classList.toggle('llsj--second-only', secondOnly);
      // The collection's six are fixed: nothing to choose, so the heading names them.
      var fixedSix = Boolean(offers.fixedSlots && offers.fixedSlots(model.offer()));
      screens.books.querySelector('h2').textContent = secondOnly ? (copy.books_title_second || 'Choose their second story') : model.offer() === 'gift-set' ? t('books_step') : fixedSix ? (copy.books_title_fixed || 'Their six books') : t('books_title');
      var lookBook = step === 'look' ? books()[previewIndex] : null;
      screens.look.querySelector('h2').textContent = (copy.look_title || 'Inside [TITLE]').split('[TITLE]').join(lookBook ? lookBook.title : t('book'));
      booksBonus.hidden = !(step === 'books' && booksLast() && showsPrintableBonus(offers, model.offer(), selected()) && children()[0]);
      if (!booksBonus.hidden) booksBonus.textContent = t('free_pdf') + ' · ' + (copy.free_pdf_title || 'My Wonderful World') + ' · ' + bookOneChild().name;
      // One book is for one child; the plural heading stays for sets.
      // Finishing names the child whose photo is still needed: the one shown,
      // or, once theirs is in, the next one Add to basket waits for (a pair can have two).
      var shownChild = list.filter(function (child) { return child.id === activeChild; })[0] || list[0];
      var waiting = finishing ? firstInvalid() : null;
      var photoChild = shownChild && !shownChild.photoFile ? shownChild : waiting && !waiting.photoFile ? waiting : null;
      var finishChild = photoChild || shownChild;
      var finishName = finishChild && finishChild.name ? finishChild.name.trim() : '';
      var needsPhoto = finishing && Boolean(photoChild);
      var forBook = childForBook && activeChild === childForBook.id ? childForBook.index : 0;
      screens.children.querySelector('h2').textContent = forBook && !finishing ? (copy.book_for_title || 'Who is Book [N] for?').replace('[N]', forBook)
        : finishing && finishName ? named(copy.finish_title || 'One last step: add [NAME]’s photo', finishName)
        : model.offer() === 'single' && copy.children_title_single ? copy.children_title_single : t('children_title');
      // The name is already in when finishing, so its "add their first name" hint goes.
      // So do the hint and the children's tabs when a book's Change asks who it
      // is for: the title says it, and the button returns to the books.
      var askingForBook = Boolean(forBook && !finishing);
      childHint.hidden = Boolean(finishing && finishName) || askingForBook;
      if (askingForBook) { tabs.hidden = true; removeChild.hidden = true; }
      // The sample names the child it was made for once a name is in.
      var firstChild = list[0], firstName = firstChild && firstChild.name ? firstChild.name.trim() : '';
      screens.sample.querySelector('h2').textContent = firstName && copy.sample_title_named && !config.colouring ? named(copy.sample_title_named, firstName) : t('sample_title');
      samplePromise.textContent = firstName && copy.preview_email_named ? named(copy.preview_email_named, firstName) : t('preview_email');
      var labels = { product: t('make_book'), offers: singlePurchaseStep() ? host.addLabel(true) : t('continue'), sample: singlePurchaseStep() ? (needsPackages() ? copy.package_sheet_open || 'Choose books' : host.addLabel(true)) : pdp ? upgradeLabel() : t('choose_package'), children: finishing ? (needsPhoto && finishName ? named(copy.finish_cta || 'Add [NAME]’s photo', finishName) : host.addLabel(true)) : returnStep === 'books' ? copy.continue_books || 'Continue to your books' : returnStep ? t('continue') : currentSteps().indexOf('sample') !== -1 ? t('preview_story') : currentSteps().indexOf('books') !== -1 ? model.offer() === 'gift-set' && config.colouring ? t('books_step') : t('choose_stories') : t('review_books'), books: booksLast() ? setEndLabel() : t('see_books'), look: setEndLabel(), review: host.addLabel(true) };
      sticky.classList.toggle('llsb__ctabar--compact', !config.colouring && step !== 'product');
      // Look inside keeps Your books' bar: the set and its price beside its button.
      sticky.classList.toggle('llsb__ctabar--review', isPreviewStep() && step !== 'look');
      sticky.classList.toggle('llsb__ctabar--set-price', pdp && !config.colouring && booksLast() && (step === 'books' || step === 'look') && model.offer() === 'two-stories');
      sticky.classList.toggle('llsb__ctabar--product', step === 'product');
      total.textContent = ''; total.hidden = (step === 'product' && !pdp) || (isPreviewStep() && step !== 'look'); exit.hidden = step === 'product';
      // Without product-page packages the sample always shows the single
      // book's price; with them it keeps the package already chosen.
      var sampleOnly = step === 'sample' && !pdp;
      var displayedOffer = sampleOnly ? config.offers[0] : selectedOffer;
      var offerName = model.offer() === 'single' || sampleOnly ? t(pdp ? 'single_story' : 'one_story') : offers.bundleTitle(selectedOffer, '');
      var name = document.createElement('span'); name.textContent = offerName;
      var amount = document.createElement('strong'); amount.textContent = displayedOffer.priceFormatted; total.appendChild(name); total.appendChild(amount);
      orderLine.textContent = ''; orderLine.appendChild(name.cloneNode(true)); orderLine.appendChild(amount.cloneNode(true));
      startPrice = displayedOffer.priceFormatted;
      // Rebuilt only when its words change, so a focused Change link stays put.
      var nextTitle = (step !== 'product' ? offerName : '') + '|' + productTitle;
      if (nextTitle !== titleSignature) {
        titleSignature = nextTitle;
        title.textContent = ''; if (step !== 'product') { var offerLabel = document.createElement('span'); offerLabel.className = 'llsj-header__offer'; offerLabel.textContent = offerName; title.appendChild(offerLabel); }
        var nameLabel = document.createElement('span'); nameLabel.className = 'llsj-header__name'; nameLabel.textContent = productTitle; title.appendChild(nameLabel);
        title.appendChild(headerChange);
      }
      headerChange.hidden = !(pdp && isPreviewStep() && step !== 'look');
      // A set's package changes from Your books, where it now ends, as it did from the Check.
      booksChange.hidden = !(pdp && step === 'books' && booksLast());
      // The sample's package rows stand in for the order card (morePackages).
      orderCard.hidden = (pdp && step === 'sample') || step === 'look';
      var ownSetDedication = (step === 'review' || (step === 'books' && booksLast())) && dedicationApi && dedicationApi.sets && dedicationApi.value();
      // A message written before a second child was added is kept in memory but not sent (dedicationOn).
      var keptDedications = ownSetDedication && twoChildren();
      var setDedicationNote = ownSetDedication && !keptDedications
        && books().some(function (book) { return book.storyId === 'finding_me' || book.storyId === 'find_christmas'; });
      orderDedication.hidden = !setDedicationNote && !keptDedications;
      if (keptDedications) orderDedication.textContent = copy.dedication_two_children || 'With two children, each book keeps its own dedication.';
      else if (setDedicationNote) orderDedication.textContent = copy.sample_more_dedication_sets || 'Your dedication goes in every story book. The Finding Me books have no dedication page.';
      booksDedication.hidden = step !== 'books' || orderDedication.hidden; booksDedication.textContent = orderDedication.textContent;
      shell.classList.toggle('llsj--single-offer', !config.colouring && model.offer() === 'single');
      syncProductCTA();
      if (!host.busy()) {
        host.buttons().forEach(function (b) { b.textContent = labels[step]; b.disabled = selectedOffer.available === false || (isPreviewStep() && step !== 'look' && (!previewReady || !!firstUnpreviewable())) || (singlePurchaseStep() && (!sampleSeen || !!firstUnpreviewable())); });
      }
      var busy = host.busy(); back.disabled = busy; exit.disabled = busy; syncQuickEdit();
      start.disabled = pdp ? selectedOffer.available === false : !config.offers.concat(config.bundles || []).some(function (offer) { return offer.available; });
      if (step === 'product' && !busy) host.buttons().forEach(function (b) { b.disabled = start.disabled; });
      if (!busy) {
        lockedControls.forEach(function (entry) { entry.node.disabled = entry.disabled; }); lockedControls = [];
      } else {
        // Freeze editable details while the original cart handler builds its
        // proof/uploads. Leave its explicit reconciliation controls usable.
        Array.prototype.forEach.call(shell.querySelectorAll('input, select, button'), function (node) {
          if (node.closest('.llsb__buy') || lockedControls.some(function (entry) { return entry.node === node; })) return;
          lockedControls.push({ node: node, disabled: node.disabled }); node.disabled = true;
        });
      }
      if (isPreviewStep()) host.previewVisibility(!coverHost.hidden);
      if (lastOffer !== currentOffer) { lastOffer = currentOffer; tabSignature = ''; dropStaleBundleParam(); }
      syncSampleEnd(isPreviewStep() ? (books()[previewIndex] || {}).child : null);
      syncPackageSheet();
      syncFinishing();
      syncReading();
      storeSelection();
    }
    /* The bar's button once a set is picked under the sample: what comes
       next. Like every journey button it names the action alone; the rows
       above carry the prices (owner, 2026-10-18). */
    /* Your books' button says what it does next (owner, 2026-10-20: it says
       Add only when it adds): while a child's photo is still needed, it names
       that photo, once every book is chosen (a book still to choose comes first). */
    function setEndLabel() {
      var waiting = emptySlot() ? null : firstInvalid(), name = waiting && waiting.name ? waiting.name.trim() : '';
      return waiting && !waiting.photoFile && offers.validName(name) ? named(copy.finish_cta || 'Add [NAME]’s photo', name) : host.addLabel(true);
    }
    function upgradeLabel() {
      return choosesBooks(model.offer()) ? (copy.more_choose_books || 'Choose 2nd story') : (copy.more_see_books || 'See all the books');
    }
    function renderReview() {
      review.textContent = ''; bookTabs.textContent = '';
      var list = books();
      if (previewIndex >= list.length) previewIndex = 0;
      list.forEach(function (book, i) {
        // A story's tab names the story (owner, 2026-10-18); colouring books keep their number.
        var tab = button(book.colouring || !book.title ? (book.colouring ? t('colouring_book') : t('book')) + ' ' + (book.index + 1) : book.title, 'llsj-book-tab', function () { previewIndex = i; renderReview(); loadPreview(); bookTabs.querySelector('[aria-pressed=true]').focus(); });
        var meta = document.createElement('small'); meta.className = 'llsj-book-tab__meta'; meta.textContent = book.colouring || !book.title ? book.title + ' · ' + book.child.name : book.child.name; tab.appendChild(meta);
        tab.setAttribute('aria-pressed', i === previewIndex ? 'true' : 'false'); bookTabs.appendChild(tab);
        if (!config.colouring || !reviewRows(model.offer())) return;
        var row = document.createElement('div'); row.className = 'llsj-review-row';
        var details = document.createElement('span'); details.textContent = book.title;
        var child = document.createElement('small'); child.textContent = t('for_child') + ' ' + book.child.name; details.appendChild(child); row.appendChild(details);
        var edit = button(t('edit'), 'llsj-link', function () { activeChild = book.child.id; returnStep = isPreviewStep() ? step : 'review'; go('children'); }); edit.setAttribute('aria-label', t('edit') + ' ' + book.child.name); row.appendChild(edit);
        review.appendChild(row);
      });
      // Look inside shows the one book it was opened for.
      bookTabs.hidden = list.length < 2 || step === 'look';
      var activeTab = bookTabs.querySelector('[aria-pressed=true]');
      if (activeTab) bookTabs.scrollLeft += activeTab.getBoundingClientRect().left - bookTabs.getBoundingClientRect().left - (bookTabs.clientWidth - activeTab.offsetWidth) / 2;
      requestAnimationFrame(syncTabOverflow);
      if (step === 'review' && showsPrintableBonus(offers, model.offer(), selected()) && list[0]) {
        var bonus = document.createElement('p'); bonus.className = 'llbo-option__bonus'; bonus.textContent = t('free_pdf') + ' · ' + (copy.free_pdf_title || 'My Wonderful World') + ' · ' + list[0].child.name; review.appendChild(bonus);
      }
      if (step === 'sample' && !pdp) return;
      review.appendChild(button(t('change_offer'), 'llsj-link', function () { if (pdp) changeFrom = step; go('offers'); }));
      if (step !== 'sample' && currentSteps().indexOf('books') !== -1) review.appendChild(button(t('edit_books'), 'llsj-link', function () { go('books'); }));
    }
    function renderPreviewLabel(book) {
      previewLabel.textContent = '';
      var sampleLabel = document.createElement('span'); sampleLabel.className = 'llsj-preview-sample';
      sampleLabel.textContent = (book.colouring ? 'Book sample' : host.renderCover || book.storyId === 'finding_me' || book.storyId === 'find_christmas' ? t('cover_sample') : t('story_sample')) + ' · ';
      previewLabel.appendChild(sampleLabel);
      previewLabel.appendChild(document.createTextNode(book.title + ' · ' + book.child.name));
    }
    function loadPreview() {
      var version = ++previewVersion, list = books(), book = list[previewIndex];
      if (!book) return;
      previewReady = false; retry.hidden = true; previewStatus.hidden = false; previewStatus.textContent = t('loading_preview');
      storyHost.hidden = true; coverHost.hidden = true; coverHost.classList.toggle('llsj-cover-preview--pages', !!book.colouring); sync();
      renderPreviewLabel(book);
      if (book.colouring) {
        showColouringPages(book, version); return;
      }
      if ((book.storyId === 'finding_me' || book.storyId === 'find_christmas') && host.bundle()) {
        coverHost.hidden = false;
        host.bundle().previewBook(coverHost, book);
        Promise.all(Array.prototype.map.call(coverHost.querySelectorAll('img'), imageReady)).then(function () {
          if (version !== previewVersion || !isPreviewStep()) return;
          previewReady = true; previewStatus.hidden = true; sync();
        }).catch(function () {
          if (version !== previewVersion || !isPreviewStep()) return;
          coverHost.hidden = true; previewStatus.textContent = t('preview_failed'); retry.hidden = false; sync();
        });
        return;
      }
      if (host.renderCover) {
        coverHost.hidden = false;
        Promise.resolve().then(function () { return host.renderCover(coverHost, book); }).then(function () {
          if (version !== previewVersion || !isPreviewStep()) return;
          previewReady = true; previewStatus.hidden = true; sync();
        }).catch(function () {
          if (version !== previewVersion || !isPreviewStep()) return;
          coverHost.hidden = true; previewStatus.textContent = t('preview_failed'); retry.hidden = false; sync();
        });
        return;
      }
      storyHost.hidden = false; host.previewVisibility(false);
      host.showPreview(book, book.child).then(function () {
        if (version !== previewVersion || !isPreviewStep()) return;
        previewReady = true; if (step === 'sample') sampleSeen = true; previewStatus.hidden = true; sync();
      }).catch(function () {
        if (version !== previewVersion || !isPreviewStep()) return;
        storyHost.hidden = true; previewStatus.textContent = t('preview_failed'); retry.hidden = false; sync();
      });
    }
    var colouringPagePositions = {}, colouringViewport = null;
    var COLOURING_PAGES = 24;
    function colouringPageLabel(index) { return index ? 'Page ' + index : 'Front cover'; }
    /* Phones read a colouring book the way ll-storybook.js lets them read a
       storybook (isScrollingBookReader): the whole book stacked in print
       order, no page controls, interiors lazily fetched as they scroll past.
       Above that width it is the storybook viewer's paged stage instead. */
    function stackedReader() { return window.matchMedia('(max-width: 989px)').matches; }
    function imageReady(image) {
      return new Promise(function (resolve, reject) {
        if (image.complete) return image.naturalWidth ? resolve() : reject(new Error('Page unavailable'));
        var timer = setTimeout(function () { reject(new Error('Page timed out')); }, 15000);
        image.addEventListener('load', function () { clearTimeout(timer); resolve(); }, { once: true });
        image.addEventListener('error', function () { clearTimeout(timer); reject(new Error('Page unavailable')); }, { once: true });
      });
    }
    function showColouringPages(book, version) {
      var currentPage = 0, pageVersion = 0, frames = [], stacked = null, media = window.matchMedia('(max-width: 989px)');
      var reader = document.createElement('div'); reader.className = 'llsj-colouring-reader';
      reader.tabIndex = 0; reader.setAttribute('aria-label', book.title + ' pages');
      /* The storybook viewer's own classes, so one set of rules in
         ll-storybook.css and the check step's desktop overrides in
         ll-storybook-journey.css dress both readers identically. */
      var stage = document.createElement('div'); stage.className = 'llsb-book__stage';
      var previous = pageButton('previous'), nextPage = pageButton('next');
      var pagesHost = document.createElement('div'); pagesHost.className = 'llsj-colouring-pages';
      stage.appendChild(previous); stage.appendChild(pagesHost); stage.appendChild(nextPage);
      var meta = document.createElement('div'); meta.className = 'llsb-book__meta';
      var pageLabel = document.createElement('p'); pageLabel.className = 'llsb-book__label';
      pageLabel.setAttribute('role', 'status'); pageLabel.setAttribute('aria-live', 'polite');
      var pageCounter = document.createElement('p'); pageCounter.className = 'llsb-book__counter';
      meta.appendChild(pageLabel); meta.appendChild(pageCounter);
      var progressTrack = document.createElement('div'); progressTrack.className = 'llsb-book__progress-track';
      progressTrack.setAttribute('aria-hidden', 'true');
      var progress = document.createElement('span'); progress.className = 'llsb-book__progress'; progressTrack.appendChild(progress);
      reader.appendChild(stage); reader.appendChild(meta); reader.appendChild(progressTrack);
      reader.addEventListener('keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey || stacked) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); turn(currentPage + (event.key === 'ArrowLeft' ? -1 : 1));
      });
      function pageButton(direction) {
        var control = button('', 'llsb-book__nav llsb-book__nav--' + direction, function () {
          turn(currentPage + (direction === 'previous' ? -1 : 1));
        });
        control.appendChild(navigationIcon(direction === 'previous' ? 'm15 18-6-6 6-6' : 'm9 6 6 6-6 6'));
        var text = document.createElement('span'); text.className = 'llsb-book__nav-text';
        text.textContent = direction === 'previous' ? 'Previous' : 'Next'; control.appendChild(text);
        return control;
      }
      function active(request) { return version === previewVersion && request === pageVersion && step === 'review'; }
      function buildFrame(pages, index) {
        var holder = document.createElement('div'); holder.className = 'llsj-colouring-page';
        var frame = document.createElement('div'); frame.className = 'llsj-colouring-frame';
        holder.appendChild(frame);
        var entry = { index: index, holder: holder, frame: frame, promise: null };
        if (!index) return entry;
        var page = pages[index - 1], image = document.createElement('img');
        image.alt = book.title + ' · ' + colouringPageLabel(index); image.className = 'llsj-colouring-art';
        image.loading = 'lazy'; image.decoding = 'async'; image.style.left = page.side ? '-100%' : '0';
        frame.appendChild(image);
        if (page.zone) {
          var zone = document.createElement('span'); zone.className = 'llsj-colouring-zone';
          zone.textContent = book.child.name + ' will be here';
          zone.style.cssText = 'left:' + page.zone.x + '%;top:' + page.zone.y + '%;width:' + page.zone.w + '%;height:' + page.zone.h + '%;';
          frame.appendChild(zone);
        }
        entry.image = image;
        entry.src = new URL(page.asset, new URL(colouringPagesUrl, location.href)).href;
        return entry;
      }
      /* A frame is filled the first time it is shown, never before: the cover
         needs a laid-out box to fit its title into, and holding an interior's
         request back is what lets a broken page be retried on its own. */
      function fill(entry) {
        if (!entry.promise) {
          var attempt = entry.image
            ? (entry.image.src = entry.src, imageReady(entry.image))
            : Promise.resolve().then(function () {
                var rendered = host.renderCover ? host.renderCover(entry.frame, book) : host.bundle().previewCover(entry.frame, book.index, true);
                // Bundle previewCover mounts synchronously; its images can still
                // be loading or fail. Keep the cover gate until they all load.
                var images = Array.prototype.map.call(entry.frame.querySelectorAll('img'), imageReady);
                return Promise.all([rendered].concat(images));
              });
          entry.promise = attempt.catch(function (error) { entry.promise = null; throw error; });
        }
        return entry.promise;
      }
      function turn(index) {
        if (index < 0 || index > COLOURING_PAGES || !frames.length || version !== previewVersion) return;
        currentPage = index; colouringPagePositions[book.storyId] = index; render();
      }
      function render() {
        if (!frames.length || version !== previewVersion) return;
        stacked = stackedReader();
        reader.classList.toggle('llsj-colouring-reader--stacked', stacked);
        frames.forEach(function (entry) { entry.holder.hidden = !stacked && entry.index !== currentPage; });
        pageLabel.textContent = colouringPageLabel(currentPage);
        pageCounter.textContent = (currentPage + 1) + ' / ' + (COLOURING_PAGES + 1);
        progress.style.transform = 'scaleX(' + ((currentPage + 1) / (COLOURING_PAGES + 1)) + ')';
        previous.disabled = !currentPage; nextPage.disabled = currentPage === COLOURING_PAGES;
        previous.setAttribute('aria-label', currentPage ? 'Previous page: ' + colouringPageLabel(currentPage - 1) : 'Previous page');
        nextPage.setAttribute('aria-label', currentPage < COLOURING_PAGES ? 'Next page: ' + colouringPageLabel(currentPage + 1) : 'Next page');
        var request = ++pageVersion;
        // Stacked, only the cover holds the basket: interiors stream in behind
        // the shopper exactly as a storybook's own scrolled spreads do.
        var gate = stacked ? frames[0] : frames[currentPage];
        if (stacked) frames.forEach(function (entry) { if (entry.index) fill(entry).catch(function () {}); });
        previewReady = false; previewStatus.hidden = false; previewStatus.textContent = t('loading_preview'); retry.hidden = true;
        coverHost.hidden = false; sync();
        fill(gate).then(function () {
          if (!active(request)) return;
          previewReady = true; previewStatus.hidden = true; sync();
        }).catch(function () {
          if (!active(request)) return;
          gate.holder.hidden = true; previewStatus.textContent = t('preview_failed'); retry.hidden = false; sync();
        });
      }
      /* One live listener at a time: every book tab builds a fresh reader, and
         a detached one left subscribed would keep its whole closure alive. */
      function onViewportChange() { if (version === previewVersion && isPreviewStep()) render(); }
      if (colouringViewport) {
        if (colouringViewport.query.removeEventListener) colouringViewport.query.removeEventListener('change', colouringViewport.handler);
        else if (colouringViewport.query.removeListener) colouringViewport.query.removeListener(colouringViewport.handler);
      }
      colouringViewport = { query: media, handler: onViewportChange };
      if (media.addEventListener) media.addEventListener('change', onViewportChange);
      else if (media.addListener) media.addListener(onViewportChange);
      colouringPages(colouringPagesUrl, book.storyId).then(function (result) {
        if (version !== previewVersion || !isPreviewStep()) return;
        for (var index = 0; index <= COLOURING_PAGES; index++) {
          var entry = buildFrame(result, index); frames.push(entry); pagesHost.appendChild(entry.holder);
        }
        coverHost.replaceChildren(reader);
        turn(colouringPagePositions[book.storyId] || 0);
      }).catch(function () {
        if (version !== previewVersion || !isPreviewStep()) return;
        previewStatus.textContent = t('preview_failed'); retry.hidden = false; sync();
      });
    }
    function next() {
      if (host.busy()) return;
      if (step === 'product') { lastFocus = start; go(firstStep()); return; }
      // The package rows come before the basket, once (package sheet).
      if (step === 'sample' && previewReady && needsPackages()) { openPackages(); return; }
      if (pdp && step === 'offers') { go(afterChange(model.offer(), changeFrom || 'sample')); return; }
      if (step === 'offers' && host.handoffStories && needsStoryHandoff(model.offer())) { host.handoffStories(model.offer()); return; }
      if ((step === 'books' || step === 'look') && booksLast()) {
        // Your books adds the set (owner, 2026-10-27). A book still to choose
        // comes first (on Your books itself), then any child's photo and tick,
        // whose button then adds; then whatever else the line still needs.
        var api = host.bundle();
        var gap = api && api.firstMissing();
        if (step === 'look' && gap && gap.slotIndex > 0) go('books');
        if (api && api.guideToMissing({ booksOnly: true })) return;
        var waiting = firstInvalid();
        if (waiting) {
          finishing = true; returnStep = 'books';
          activeChild = waiting.id; tabSignature = ''; go('children');
          if (!waiting.photoFile && !waiting.checking && offers.validName(waiting.name)) focusPhoto();
          else if (waiting.id === PRIMARY) host.guidePrimary(); else editors[waiting.id].guide();
          return;
        }
        if (api) api.guideToMissing();
        return;
      }
      if (step === 'children' || isPreviewStep() || singlePurchaseStep()) {
        // Moving on to a sample needs a name; buying also needs the photo and consent.
        // A set picked under the single book's sample is not bought from the
        // sample: it goes on to its books and the check first, and only the
        // check's Add to basket asks for the photo (2026-10-19: it used to
        // buy a default second story nobody chose).
        var setFromSample = pdp && upsold && step === 'sample' && model.offer() !== 'single';
        var buying = !setFromSample && (isPreviewStep() || singlePurchaseStep() || (step === 'children' && finishing));
        var child = buying ? firstInvalid() : firstUnpreviewable();
        if (child) {
          // On the finishing screen the button reads "Add [NAME]'s photo": it opens that child's picker.
          if (step === 'children' && finishing && child.id === activeChild && !child.photoFile && !child.checking && offers.validName(child.name)) {
            var picker = panes[child.id] && panes[child.id].querySelector('input[type=file]');
            if (picker) { picker.click(); return; }
          }
          if (buying && step !== 'children') { finishing = true; returnStep = step; }
          activeChild = child.id; tabSignature = ''; go('children');
          // Finishing without a photo: the friendly line above the upload says it (syncFinishing), no red error.
          if (finishing && !child.photoFile && !child.checking && offers.validName(child.name)) focusPhoto();
          else if (child.id === PRIMARY) host.guidePrimary(); else editors[child.id].guide();
          return;
        }
      }
      if (step === 'children') {
        refreshBundle();
        if (returnStep) { var destination = returnStep; returnStep = null; go(destination); return; }
      }
      if (step === 'sample' && !previewReady) return;
      // The book step checks the choices; the photo and consent wait for Add to basket.
      if (step === 'books' && host.bundle().guideToMissing({ booksOnly: true })) return;
      var list = currentSteps(), index = list.indexOf(step);
      if (index + 1 < list.length) go(list[index + 1]);
    }
    // True when this tab held a saved choice and it is the one used: only
    // then does a reload's notice say the choice is saved (2026-10-28).
    function restoreSelection() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!saved || saved.version !== 1 || saved.expires < Date.now() || !Array.isArray(saved.stories)) return false;
        var requested = offers.requestedBundleId ? offers.requestedBundleId() : '';
        // An explicit available bundle link takes priority over an older draft.
        if (requested && requested !== saved.offer && config.bundles.some(function (b) { return b.id === requested && b.available; })) return false;
        if (config.bundles.some(function (b) { return b.id === saved.offer && b.available; })) host.select(saved.offer);
        var api = host.bundle();
        if (api && saved.offer !== 'single') {
          // Restore atomically only a valid unique set; never swap one book
          // underneath another while reconstructing a previous selection.
          api.restoreStories(saved.stories);
        }
        return true;
      } catch (error) { /* A fresh draft is always usable without storage. */ return false; }
    }
    // Mount returns before booting so the host can expose this roster to the
    // shared configurator without a re-entrant half-initialised controller.
    return {
      start: function () {
        var offerBefore = host.offer(), draft = restoreSelection(); model.select(host.offer()); sync();
        // A choice restored from this session reopens at the product page (the
        // customer left on purpose); a bundle the host preselected (a handoff)
        // opens the journey at its first step.
        var restoredBundle = host.offer() !== offerBefore;
        if (/^#make\//.test(location.hash)) {
          var routed = routeStep(location.hash, Boolean(config.colouring));
          // A link opened in a fresh tab has nothing saved to speak of.
          if (draft && (routed === 'children' || routed === 'sample' || routed === 'books' || routed === 'look' || routed === 'review')) { notice.textContent = t('reload_details'); notice.hidden = false; }
          go(routed, true);
        }
        else if (!restoredBundle && host.offer() !== 'single') go(firstStep(), true);
        else go('product', true);
        window.addEventListener('popstate', function () {
          var from = history.state && history.state.llsjChangeFrom;
          if (pdp && from && routeStep(location.hash, false) === 'offers') changeFrom = from;
          go(routeStep(location.hash, Boolean(config.colouring)), true);
        });
      },
      sync: sync, children: children, recipients: model.recipients,
      assign: function (index, id) { model.assign(index, id); storeSelection(); },
      next: next, step: function () { return step; },
      canSubmit: function () { return ((step === 'review' && previewReady) || (singlePurchaseStep() && sampleSeen && (!pdp || previewReady) && !needsPackages()) || (step === 'children' && finishing) || ((step === 'books' || step === 'look') && booksLast() && host.bundle() && host.bundle().isReady())) && !firstInvalid(); },
      /* Look inside one chosen book from Your books (the configurator's
         lookInside): index is the slot's position, which books() keeps while
         it skips a slot still to choose. */
      look: function (index) {
        if (host.busy() || !booksLast()) return;
        var at = -1;
        books().forEach(function (book, i) { if (book.index === index) at = i; });
        if (at === -1) return;
        previewIndex = at; go('look');
      },
      addChildForBooks: addChildForBooks,
      // Look inside is a view of Your books only where it ends the set (not the packages-off journey).
      canLook: function () { return booksLast(); },
      clear: function () { completed = true; try { sessionStorage.removeItem(storageKey); } catch (error) {} }
    };
  }
})();
